var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImagenLogin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 511.166,
    height: 453.816,
    viewBox: "0 0 511.166 453.816",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17914",
    "data-name": "Grupo 17914",
    transform: "translate(-7.775 -47.868)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M597,294.823C597,153.669,482.568,39.241,341.414,39.241S85.83,153.669,85.83,294.823a254.473,254.473,0,0,0,54.02,157.151H542.977A254.479,254.479,0,0,0,597,294.823",
    transform: "translate(-78.055 26.758)",
    fill: "rgba(224,42,88,0.38)",
    opacity: 0.996
  }), /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(54.775 477.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17497",
    "data-name": "Grupo 17497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17496",
    "data-name": "Grupo 17496"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12825",
    "data-name": "Trazado 12825",
    d: "M463.453,465.387c0,.148-93.243.268-208.237.268-115.035,0-208.258-.12-208.258-.268s93.222-.268,208.258-.268C370.211,465.119,463.453,465.239,463.453,465.387Z",
    transform: "translate(-46.959 -465.119)",
    fill: "#1b202c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Contract",
    transform: "translate(43.112 47.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17550",
    "data-name": "Grupo 17550"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17498",
    "data-name": "Grupo 17498",
    transform: "translate(53.843 24.163)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12826",
    "data-name": "Trazado 12826",
    d: "M259.991,73.81l49.591-2.094a16.08,16.08,0,0,1,16.755,15.7l1.752,76.6a16.081,16.081,0,0,1-14.406,16.363h0a5.343,5.343,0,0,0-4.785,5.52l6.23,161.786A20.07,20.07,0,0,1,295.963,368.5l-189.448,8.411a5.343,5.343,0,0,1-5.578-5.179L92.555,90.9a5.343,5.343,0,0,1,4.961-5.489Z",
    transform: "translate(-92.553 -71.701)",
    fill: "#e02a58",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17499",
    "data-name": "Grupo 17499",
    transform: "translate(62.068 24.54)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12827",
    "data-name": "Trazado 12827",
    d: "M100.533,366.414l.159,5.309,203.943-18.752-3.9-280.9s-49.506,7.5-50.406,7.5S100.533,366.414,100.533,366.414Z",
    transform: "translate(-100.533 -72.067)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17503",
    "data-name": "Grupo 17503",
    transform: "translate(21.549 7.454)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17500",
    "data-name": "Grupo 17500",
    transform: "translate(0.221 0.131)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12828",
    "data-name": "Trazado 12828",
    d: "M235.128,59.227l59.185-3.609,6.11,291.151L92.113,367.9,61.435,78.272Z",
    transform: "translate(-61.435 -55.617)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17502",
    "data-name": "Grupo 17502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17501",
    "data-name": "Grupo 17501"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12829",
    "data-name": "Trazado 12829",
    d: "M235.134,59.23s-1.038.134-3.067.366l-9,1.016-34.6,3.848-127,14.016.177-.221c8.237,77.6,18.938,178.4,30.744,289.616l-.293-.238,46.692-4.736L300.4,346.519l-.228.259c-2.615-127.3-4.759-231.709-5.979-291.154l.131.121-44.045,2.626-11.316.659c-2.54.144-3.832.2-3.832.2s1.289-.1,3.827-.266l11.311-.722L294.312,55.5l.129-.008,0,.129c1.275,59.444,3.513,163.851,6.241,291.149l.005.235-.234.023L138.839,363.431l-46.693,4.734-.265.027-.028-.265C80.1,256.707,69.444,155.9,61.242,78.3l-.021-.2.2-.022L188.443,64.238,223.052,60.5l9.009-.959C234.092,59.324,235.134,59.23,235.134,59.23Z",
    transform: "translate(-61.221 -55.49)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17507",
    "data-name": "Grupo 17507",
    transform: "translate(11.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17504",
    "data-name": "Grupo 17504",
    transform: "translate(0 0.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12830",
    "data-name": "Trazado 12830",
    d: "M51.393,68.821l28.2,293.019,218.166-20.551L266.3,48.489Z",
    transform: "translate(-51.393 -48.489)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17506",
    "data-name": "Grupo 17506",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17505",
    "data-name": "Grupo 17505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12831",
    "data-name": "Trazado 12831",
    d: "M51.393,68.828,266.276,48.279l.215-.021.023.215c8.847,82.2,19.742,183.438,31.511,292.794l.029.271-.27.025-1.547.146L79.615,362.089l-.241.023-.023-.241C62.8,188.372,51.6,70.964,51.393,68.828c.207,2.134,11.6,119.524,28.441,293l-.264-.219,216.618-20.431,1.546-.145-.242.3C285.76,231.965,274.9,130.72,266.079,48.52l.238.194Z",
    transform: "translate(-51.393 -48.258)",
    fill: "#1b202c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17519",
    "data-name": "Grupo 17519",
    transform: "translate(37.21 75.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17518",
    "data-name": "Grupo 17518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12844",
    "data-name": "Trazado 12844",
    d: "M260.361,121.624c.014.148-41.156,4.156-91.943,8.951-50.805,4.8-91.988,8.565-92,8.417s41.146-4.154,91.951-8.951C219.155,125.246,260.348,121.477,260.361,121.624Z",
    transform: "translate(-76.416 -121.62)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17521",
    "data-name": "Grupo 17521",
    transform: "translate(36.427 73.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17520",
    "data-name": "Grupo 17520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12845",
    "data-name": "Trazado 12845",
    d: "M160.571,119.389c.014.148-18.985,2.062-42.429,4.276s-42.471,3.889-42.485,3.742,18.982-2.061,42.435-4.276S160.556,119.242,160.571,119.389Z",
    transform: "translate(-75.656 -119.38)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17523",
    "data-name": "Grupo 17523",
    transform: "translate(38.012 87.555)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17522",
    "data-name": "Grupo 17522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12846",
    "data-name": "Trazado 12846",
    d: "M261.139,133.208c.014.147-41.156,4.155-91.943,8.951-50.805,4.8-91.988,8.564-92,8.417s41.146-4.155,91.951-8.952C219.933,136.829,261.126,133.06,261.139,133.208Z",
    transform: "translate(-77.194 -133.204)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17525",
    "data-name": "Grupo 17525",
    transform: "translate(38.814 99.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17524",
    "data-name": "Grupo 17524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12847",
    "data-name": "Trazado 12847",
    d: "M261.917,144.791c.014.147-41.156,4.155-91.943,8.951-50.805,4.8-91.988,8.564-92,8.417s41.146-4.155,91.951-8.952C220.711,148.412,261.9,144.644,261.917,144.791Z",
    transform: "translate(-77.972 -144.787)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17527",
    "data-name": "Grupo 17527",
    transform: "translate(39.616 111.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17526",
    "data-name": "Grupo 17526"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12848",
    "data-name": "Trazado 12848",
    d: "M262.695,156.374c.014.147-41.156,4.156-91.943,8.951-50.805,4.8-91.988,8.564-92,8.417s41.146-4.155,91.951-8.952C221.489,160,262.682,156.227,262.695,156.374Z",
    transform: "translate(-78.75 -156.37)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17529",
    "data-name": "Grupo 17529",
    transform: "translate(40.418 123.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17528",
    "data-name": "Grupo 17528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12849",
    "data-name": "Trazado 12849",
    d: "M263.473,167.957c.014.147-41.156,4.156-91.943,8.951-50.805,4.8-91.988,8.564-92,8.417s41.146-4.154,91.951-8.951C222.267,171.578,263.46,167.81,263.473,167.957Z",
    transform: "translate(-79.528 -167.953)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17531",
    "data-name": "Grupo 17531",
    transform: "translate(41.22 135.31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17530",
    "data-name": "Grupo 17530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12850",
    "data-name": "Trazado 12850",
    d: "M264.251,179.54c.014.148-41.156,4.156-91.943,8.951-50.805,4.8-91.988,8.565-92,8.418s41.146-4.155,91.951-8.952C223.045,183.162,264.238,179.393,264.251,179.54Z",
    transform: "translate(-80.306 -179.536)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17533",
    "data-name": "Grupo 17533",
    transform: "translate(44.423 147.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17532",
    "data-name": "Grupo 17532"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12851",
    "data-name": "Trazado 12851",
    d: "M264.957,191.124c.014.147-40.618,4.1-90.742,8.837-50.141,4.734-90.788,8.451-90.8,8.3s40.609-4.1,90.751-8.838C224.289,194.695,264.944,190.977,264.957,191.124Z",
    transform: "translate(-83.414 -191.12)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17535",
    "data-name": "Grupo 17535",
    transform: "translate(45.477 170.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17534",
    "data-name": "Grupo 17534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12852",
    "data-name": "Trazado 12852",
    d: "M194.047,213.4c.012.147-24.516,2.477-54.779,5.2s-54.819,4.816-54.832,4.667,24.51-2.476,54.784-5.2S194.033,213.257,194.047,213.4Z",
    transform: "translate(-84.436 -213.397)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17537",
    "data-name": "Grupo 17537",
    transform: "translate(58.579 268.886)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17536",
    "data-name": "Grupo 17536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12853",
    "data-name": "Trazado 12853",
    d: "M163.873,309.143c.012.147-14.916,1.536-33.339,3.1s-33.374,2.713-33.386,2.565,14.911-1.536,33.341-3.1S163.86,309,163.873,309.143Z",
    transform: "translate(-97.148 -309.131)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17539",
    "data-name": "Grupo 17539",
    transform: "translate(59.178 280.276)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17538",
    "data-name": "Grupo 17538",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12854",
    "data-name": "Trazado 12854",
    d: "M135.182,320.2c.012.147-8.362.979-18.7,1.857s-18.737,1.471-18.75,1.322,8.36-.979,18.7-1.857S135.17,320.055,135.182,320.2Z",
    transform: "translate(-97.729 -320.181)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17541",
    "data-name": "Grupo 17541",
    transform: "translate(50.267 196.255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17540",
    "data-name": "Grupo 17540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12855",
    "data-name": "Trazado 12855",
    d: "M133.15,238.68c.014.147-9.839,1.239-22.006,2.439s-22.047,2.051-22.061,1.9,9.837-1.239,22.009-2.439S133.136,238.533,133.15,238.68Z",
    transform: "translate(-89.083 -238.664)",
    fill: "#e02a58",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17542",
    "data-name": "Grupo 17542",
    transform: "translate(34.433 243.257)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12856",
    "data-name": "Trazado 12856",
    d: "M74.411,305.019l20.026-3.871,11.2-16.882L73.721,294.746Z",
    transform: "translate(-73.721 -284.265)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17545",
    "data-name": "Grupo 17545",
    transform: "translate(0 237.371)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17543",
    "data-name": "Grupo 17543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12857",
    "data-name": "Trazado 12857",
    d: "M40.314,283.616l53.473-5.062,12.875,5.886L96.386,296l-54.318,5.856Z",
    transform: "translate(-40.314 -278.554)",
    fill: "#e02a58",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("text", {
    id: "Firma",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 13.379, 15.59)",
    fill: "#fff",
    fontSize: 9,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "FIRMA"))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17547",
    "data-name": "Grupo 17547",
    transform: "translate(76.301 194.951)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17546",
    "data-name": "Grupo 17546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12862",
    "data-name": "Trazado 12862",
    d: "M200.181,237.4s.063.016.184.061a2.583,2.583,0,0,1,.521.245,7.449,7.449,0,0,1,1.72,1.455,24.657,24.657,0,0,1,4.333,7.472,31.3,31.3,0,0,1,2.247,13.454,20.346,20.346,0,0,1-.73,4.1,27.372,27.372,0,0,1-7.354,11.831,28.57,28.57,0,0,1-8.834,5.779,24.2,24.2,0,0,1-11.283,1.775,24.754,24.754,0,0,1-19.812-14.15,20.19,20.19,0,0,1-1.792-6.549,15.388,15.388,0,0,1,.72-6.91,11.11,11.11,0,0,1,4.117-5.769,7.993,7.993,0,0,1,3.43-1.282,8.212,8.212,0,0,1,3.668.43,10.829,10.829,0,0,1,5.653,4.69,17.4,17.4,0,0,1,2.243,7.144,31.208,31.208,0,0,1-2.2,15,29.519,29.519,0,0,1-9.063,12.141A27.211,27.211,0,0,1,154.3,293.8a25.578,25.578,0,0,1-14-2.28,23.921,23.921,0,0,1-9.96-9.254,23.216,23.216,0,0,1-3.37-12.5,16.94,16.94,0,0,1,1.2-6.15,12.194,12.194,0,0,1,3.523-4.947,7.288,7.288,0,0,1,5.59-1.653,8.368,8.368,0,0,1,4.929,2.744,10.49,10.49,0,0,1,2.473,4.837,13.615,13.615,0,0,1-.007,5.2,26.98,26.98,0,0,1-3.667,8.869,42.636,42.636,0,0,1-5.149,6.846,46.616,46.616,0,0,1-5.48,5.051,47.463,47.463,0,0,1-5.216,3.468,40.168,40.168,0,0,1-7.917,3.493c-1.887.6-2.908.809-2.908.809s.245-.089.731-.235,1.217-.329,2.143-.676a41.634,41.634,0,0,0,7.847-3.572,47.74,47.74,0,0,0,5.163-3.489,46.69,46.69,0,0,0,5.416-5.052,42.463,42.463,0,0,0,5.078-6.819,26.725,26.725,0,0,0,3.587-8.761,13.258,13.258,0,0,0-.008-5.05,10.105,10.105,0,0,0-2.39-4.64,7.947,7.947,0,0,0-4.68-2.6,6.845,6.845,0,0,0-5.253,1.574A11.736,11.736,0,0,0,128.6,263.8a16.466,16.466,0,0,0-1.155,5.988,22.747,22.747,0,0,0,3.323,12.23,23.435,23.435,0,0,0,9.759,9.046,25.064,25.064,0,0,0,13.721,2.219,26.689,26.689,0,0,0,13.373-5.388,28.992,28.992,0,0,0,8.9-11.922,30.7,30.7,0,0,0,2.168-14.739,16.858,16.858,0,0,0-2.166-6.927,10.3,10.3,0,0,0-5.372-4.467,7.671,7.671,0,0,0-3.435-.408,7.47,7.47,0,0,0-3.2,1.195,10.6,10.6,0,0,0-3.921,5.5,14.88,14.88,0,0,0-.7,6.692,19.723,19.723,0,0,0,1.742,6.4,24.306,24.306,0,0,0,19.4,13.912,23.806,23.806,0,0,0,11.087-1.715,28.22,28.22,0,0,0,8.727-5.67,27.1,27.1,0,0,0,7.309-11.646,20.028,20.028,0,0,0,.738-4.033,31.265,31.265,0,0,0-2.142-13.354,25.093,25.093,0,0,0-4.219-7.476,7.755,7.755,0,0,0-1.668-1.48C200.434,237.478,200.171,237.425,200.181,237.4Z",
    transform: "translate(-114.342 -237.399)",
    fill: "#3e3e3c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17549",
    "data-name": "Grupo 17549",
    transform: "translate(63.97 21.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17548",
    "data-name": "Grupo 17548"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12863",
    "data-name": "Trazado 12863",
    d: "M217.016,98.377s-.03-.175-.07-.505c-.04-.346-.1-.832-.17-1.466-.144-1.3-.357-3.2-.631-5.665-.538-4.946-1.32-12.149-2.311-21.261l.178.144L102.708,81.358H102.7l.239-.295c1.035,9.921,2.044,19.6,3.015,28.915l-.289-.234,79.432-8.178L208.5,99.2l6.307-.625,1.641-.154c.372-.033.571-.043.571-.043s-.174.03-.534.073l-1.6.184-6.244.687-23.323,2.511-79.59,8.434-.261.027-.028-.261c-.975-9.313-1.987-18.993-3.026-28.914l-.028-.267.267-.028h.007L213.979,69.3l.162-.018.016.162c.918,9.161,1.644,16.4,2.143,21.375.238,2.452.423,4.341.548,5.637.058.624.1,1.1.134,1.441C217.01,98.221,217.016,98.377,217.016,98.377Z",
    transform: "translate(-102.378 -69.285)",
    fill: "#1b202c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17916",
    "data-name": "Grupo 17916",
    transform: "translate(179.046 216.045) rotate(-5)",
    opacity: 0.677
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4839",
    "data-name": "Trazado 4839",
    d: "M47.322,11.777A39.431,39.431,0,0,0,29.187,1.158C21.724-.836,15.21-.264,9.687,2.948v.041C3.214,6.69,0,12.671,0,20.81A31.409,31.409,0,0,0,5.689,38.793a43.94,43.94,0,0,0,6.058,7.2c7.75,7.527,16.324,11.312,25.64,11.352,8.163,0,14.223-3.092,18.1-9.194a20.54,20.54,0,0,0,3.091-9.36,25.879,25.879,0,0,0-.865-9.235A38,38,0,0,0,47.322,11.777M29.6,4.129a34.372,34.372,0,0,1,16.037,9.235A33.922,33.922,0,0,1,54.742,29.07a23.156,23.156,0,0,1,.372,9.723,17.791,17.791,0,0,1-2.68,6.389c-3.422,5.084-8.7,7.527-15.79,7.4-7.83-.161-15-3.457-21.516-9.765a39.745,39.745,0,0,1-3.587-4.028,28.373,28.373,0,0,1-6.6-17.252C4.822,14.585,7.419,9.417,12.819,6.08V6.04C17.518,3.112,23.083,2.5,29.6,4.129",
    transform: "translate(0 0)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4840",
    "data-name": "Trazado 4840",
    d: "M1.1.055C.232-.149-.1.219.025,1.032l.33,2.116A1.78,1.78,0,0,0,1.921,4.653L4.148,5.1c.784.162,1.112-.2.948-1.017L4.766,2.05A1.874,1.874,0,0,0,3.24.544Z",
    transform: "translate(37.115 13.349)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4841",
    "data-name": "Trazado 4841",
    d: "M4.5,5.549c.989.162,1.4-.206,1.318-1.059L5.534,2.251A1.743,1.743,0,0,0,3.967.624L1.369.055C.38-.148-.072.217.009,1.072L.258,3.351c.04.9.576,1.424,1.608,1.627Z",
    transform: "translate(18.746 9.443)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4842",
    "data-name": "Trazado 4842",
    d: "M5.658,4.485l-.5-2.606C4.958.861,4.462.333,3.556.292L1.165.01C.258-.073-.155.375.052,1.351L.505,4.036A1.734,1.734,0,0,0,2.2,5.663l2.432.2c.866.083,1.237-.407,1.031-1.382",
    transform: "translate(41.211 36.669)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4843",
    "data-name": "Trazado 4843",
    d: "M4.847,1.886A1.692,1.692,0,0,0,3.362.421L1.178.056C.272-.149-.1.217.023,1.031L.436,3.27A1.779,1.779,0,0,0,2,4.814l2.267.367C5.093,5.3,5.423,4.937,5.3,4.125Z",
    transform: "translate(38.024 18.802)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4844",
    "data-name": "Trazado 4844",
    d: "M.052,1.122.463,3.563A1.749,1.749,0,0,0,2.072,5.109l2.265.284c.868.122,1.238-.243,1.075-1.137l-.455-2.32A1.7,1.7,0,0,0,3.432.429L1.2.023C.258-.1-.155.267.052,1.122",
    transform: "translate(39.026 24.449)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4845",
    "data-name": "Trazado 4845",
    d: "M5.7,2.17A1.829,1.829,0,0,0,4.09.543L1.411.055C.421-.148-.074.217.009,1.112l.2,2.441A1.8,1.8,0,0,0,1.9,5.221l2.721.408c.949.2,1.4-.2,1.318-1.1Z",
    transform: "translate(19.283 15.262)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4846",
    "data-name": "Trazado 4846",
    d: "M4.759,5.869c1.032.162,1.443-.284,1.32-1.22L5.791,2.168A1.739,1.739,0,0,0,4.142.459L1.419.051C.39-.152-.105.255.019,1.23L.225,3.8A1.722,1.722,0,0,0,1.958,5.462Z",
    transform: "translate(19.849 21.369)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4847",
    "data-name": "Trazado 4847",
    d: "M3.978.4,1.341.033C.31-.13-.1.318.021,1.333L.31,3.98A1.816,1.816,0,0,0,2.042,5.687l2.72.287Q6.183,6.094,6,4.63l-.374-2.6A1.728,1.728,0,0,0,3.978.4",
    transform: "translate(27.391 28.711)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4848",
    "data-name": "Trazado 4848",
    d: "M4.88,6.124c1.031.162,1.525-.326,1.4-1.3L5.994,2.093A1.85,1.85,0,0,0,4.262.386L1.5.02C.429-.1-.107.344.018,1.322L.266,4.088a1.805,1.805,0,0,0,1.77,1.789Z",
    transform: "translate(20.429 27.788)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4849",
    "data-name": "Trazado 4849",
    d: "M4.388.3,1.544.019C.389-.1-.105.344.018,1.484l.29,2.889A1.7,1.7,0,0,0,2.121,6.163l2.927.244c1.071.081,1.567-.446,1.441-1.464L6.161,2.055A1.829,1.829,0,0,0,4.388.3",
    transform: "translate(21.045 34.624)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4850",
    "data-name": "Trazado 4850",
    d: "M5.022,1.9A1.667,1.667,0,0,0,3.5.36L1.23.035C.282-.128-.13.279.036,1.256L.448,3.778a1.829,1.829,0,0,0,1.69,1.587l2.39.284c.825.083,1.195-.325,1.032-1.261Z",
    transform: "translate(40.073 30.377)",
    fill: "#be0031"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4851",
    "data-name": "Trazado 4851",
    d: "M3.69.4,1.259.033C.311-.13-.1.316.021,1.294L.4,3.9A1.8,1.8,0,0,0,2.082,5.526l2.475.243c.988.123,1.36-.284,1.194-1.26L5.339,1.946A1.686,1.686,0,0,0,3.69.4",
    transform: "translate(33.945 29.565)",
    fill: "#be0031"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Documento",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 72.117, 51.619)",
    fill: "#1b202c",
    fontSize: 13,
    fontFamily: "Montserrat-ExtraBold, Montserrat",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DOCUMENTO")))), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(205.039 113.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17913",
    "data-name": "Grupo 17913",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17861",
    "data-name": "Grupo 17861",
    transform: "translate(74.95)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17735",
    "data-name": "Grupo 17735",
    transform: "translate(66.344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17551",
    "data-name": "Grupo 17551",
    transform: "translate(0.017 0.205)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12864",
    "data-name": "Trazado 12864",
    d: "M334.563,146.812a2.667,2.667,0,0,1,.969-1.553,6.6,6.6,0,0,1,4.1-1.013,17.409,17.409,0,0,0,1.678-5.438,3.472,3.472,0,0,1-1.932-.55,1.931,1.931,0,0,1-.318-.1c-1.376-.631-1.511-2.686-.644-3.927a7.85,7.85,0,0,1,3.763-2.417c-1.037.063-1.922.748-2.914,1.056s-2.388-.032-2.506-1.065a2.252,2.252,0,0,1,.158-.93q.289-.915.581-1.831a2.044,2.044,0,0,1,.806-1.277,4.79,4.79,0,0,1,1.056-.254c1.16-.312,1.759-1.72,2.916-2.045a5.319,5.319,0,0,1,2.59.383c.861.2,2,.035,2.267-.808a8.269,8.269,0,0,1-2.948-2.491,2.834,2.834,0,0,1,.279-3.565,4.166,4.166,0,0,1,2.915-.6c1.134.05,2.544.308,2.843,1.4a2.95,2.95,0,0,1,3.62,2.314l2.92-.3c-.815-.877-1.974-1.411-2.678-2.38s-.574-2.714.6-2.965a8.063,8.063,0,0,0,1.3-.114c.294-.116.536-.381.852-.394a1.137,1.137,0,0,1,.63.247l6.168,4.024-1.667-3.877c-.513-1.192-.911-2.834.156-3.572,1.032-.713,2.54.316,2.757,1.552a2,2,0,0,1,2.438,1.845,2.032,2.032,0,0,1,2.388,3.1,5.769,5.769,0,0,1,2.934.876,1.768,1.768,0,0,1,2.857-1.217,3.079,3.079,0,0,1,.453-1.758,1.064,1.064,0,0,1,1.591-.177,2.066,2.066,0,0,1,3.346-2.022q.507-.615,1.016-1.23a2.718,2.718,0,0,1,2.621,1.36c.429.952-.289,2.323-1.329,2.229.731-.012.566,1.155.138,1.749l-1.784,2.481a2.286,2.286,0,0,1,2.83-.25,1.768,1.768,0,0,1,2.556.02,1.432,1.432,0,0,1,2.573.435c.181-.478.837-.507,1.345-.451a3.326,3.326,0,0,1,2.039.7c.522.515.517,1.584-.17,1.838.625-.35,1.43.338,1.44,1.054a2.563,2.563,0,0,1-1.026,1.812,5.981,5.981,0,0,0-1.47,1.547,3.025,3.025,0,0,1,2.062-.435,7.839,7.839,0,0,1,3.732.744c.219-.5.921-.527,1.461-.416a8.735,8.735,0,0,1,4.45,2.419c.567.577,1.076,1.443.689,2.154a2.168,2.168,0,0,1-.817.726l-3.959,2.45a10.78,10.78,0,0,1,5.412,3.835c.792.46,1.8.508,2.512,1.079s.664,2.08-.253,2.079a1.68,1.68,0,0,1,.486,1.948,1.6,1.6,0,0,1-.617.681,2.282,2.282,0,0,1-.434.491,3.1,3.1,0,0,1-1.064.558,2.069,2.069,0,0,1-1.77.816,8.439,8.439,0,0,1,1.882,2.229,3.532,3.532,0,0,1,0,3.632,1.964,1.964,0,0,1-.14.154,1.726,1.726,0,0,1-.758,1.1,1.459,1.459,0,0,1,.14.965,3.863,3.863,0,0,1,.869,6.772c-.91.643-2.6.525-2.684-.586a3.007,3.007,0,0,1-2.284,1.663,2.913,2.913,0,0,1-1.524,4.012,3.1,3.1,0,0,1-.976,5.079,2.378,2.378,0,1,1-4.493,1.559,5.039,5.039,0,0,1-1.78,2.228,1.745,1.745,0,0,1-2.461-.643,3.265,3.265,0,0,1-4.8,1.554,2.112,2.112,0,0,1-4.2.371l-5.455-.053a19.431,19.431,0,0,1-3.605-.26,9.772,9.772,0,0,1-4.156-1.923,3.3,3.3,0,0,0-1.259-.766,3.4,3.4,0,0,0-1.668.257,8.825,8.825,0,0,1-8.383-1.982,4.423,4.423,0,0,0-1.106-.882,3.984,3.984,0,0,0-1.61-.223,15.917,15.917,0,0,1-3.964-.571,4.213,4.213,0,0,1-2.8-1.835c-.522-1.023.091-2.6,1.24-2.585a2.465,2.465,0,0,0-.609-2.072,1.483,1.483,0,0,0-2.014-.083,1.068,1.068,0,0,0,.491,1.741c-1.234.85-3.15-.343-3.181-1.842a2.949,2.949,0,0,1,2.956-2.752,6.78,6.78,0,0,1-.085-3.3,2.426,2.426,0,0,1-3.3.374,4.176,4.176,0,0,1-2.706,1.945,2.5,2.5,0,0,1-2.764-1.51,1.8,1.8,0,0,1,1.713-2.322,2.155,2.155,0,0,1,1.915-3.118,3.353,3.353,0,0,1,2.047-3.559,1.765,1.765,0,0,1-2.511-.969c-.695,1.095-2.385.827-3.5.171A2.357,2.357,0,0,1,334.563,146.812Z",
    transform: "translate(-334.516 -112.549)",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17554",
    "data-name": "Grupo 17554"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17553",
    "data-name": "Grupo 17553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12865",
    "data-name": "Trazado 12865",
    d: "M334.564,146.818a1.716,1.716,0,0,0-.063.445,1.933,1.933,0,0,0,.417,1.256,4.251,4.251,0,0,0,1.814,1.245,3.684,3.684,0,0,0,1.414.24,1.762,1.762,0,0,0,1.438-.76l-.119-.018a1.839,1.839,0,0,0,2.615,1.018l-.07-.14a3.449,3.449,0,0,0-2.111,3.648l.1-.108a2.081,2.081,0,0,0-1.875,1.007,2.122,2.122,0,0,0-.138,2.259l.1-.161a1.817,1.817,0,0,0-1.827,1.374,1.99,1.99,0,0,0,.921,2.261,2.879,2.879,0,0,0,2.628.243,4.657,4.657,0,0,0,2.131-1.815l-.189.03a2.564,2.564,0,0,0,3.492-.392l-.241-.113a6.945,6.945,0,0,0,.081,3.366l.136-.181a3.312,3.312,0,0,0-2.03.754,2.782,2.782,0,0,0-1.068,1.965,2.317,2.317,0,0,0,1.076,2.023,2.085,2.085,0,0,0,2.338.124l.347-.239-.416-.045a.865.865,0,0,1-.608-1.025.948.948,0,0,1,1.034-.753,1.464,1.464,0,0,1,1.245.757,2.539,2.539,0,0,1,.276,1.571l.167-.145a1.418,1.418,0,0,0-1.085.505,2.1,2.1,0,0,0-.485,1.078,2.068,2.068,0,0,0,.15,1.185,2.8,2.8,0,0,0,.731.937,5.659,5.659,0,0,0,2.1,1.021,16.072,16.072,0,0,0,2.3.474c1.541.324,3.324-.3,4.332,1.127a8.887,8.887,0,0,0,4.4,2.264,9.106,9.106,0,0,0,2.552.152,13.024,13.024,0,0,0,2.507-.549,1.535,1.535,0,0,1,1.12.126,8.969,8.969,0,0,1,1.017.75,10.1,10.1,0,0,0,2.325,1.3,13.992,13.992,0,0,0,5.325.766l5.472.058-.2-.175a2.321,2.321,0,0,0,4.615-.408l-.335.176a3.481,3.481,0,0,0,5.128-1.658l-.405.007a1.584,1.584,0,0,0,1.164.968,2.266,2.266,0,0,0,1.537-.176,5.11,5.11,0,0,0,1.936-2.349l-.4-.03a2.6,2.6,0,1,0,4.907-1.7l-.142.283a3.1,3.1,0,0,0,1.981-2.359,3.142,3.142,0,0,0-.929-3.1l-.07.385a3.142,3.142,0,0,0,1.648-4.336l-.167.336a3.247,3.247,0,0,0,2.46-1.789l-.433-.079a1.181,1.181,0,0,0,.355.754,1.545,1.545,0,0,0,.714.371,2.579,2.579,0,0,0,1.519-.127,3.849,3.849,0,0,0,1.953-2.268,3.964,3.964,0,0,0-.158-3.042,4.188,4.188,0,0,0-2.26-2.109l.145.263a1.7,1.7,0,0,0-.161-1.115l-.087.3a1.964,1.964,0,0,0,.864-1.243l-.053.1a3.438,3.438,0,0,0,.442-3.447,7.521,7.521,0,0,0-2.2-2.9l-.175.405a2.309,2.309,0,0,0,1.976-.907l-.116.081a2.92,2.92,0,0,0,1.621-1.141l-.068.067a1.75,1.75,0,0,0,.853-1.424,1.909,1.909,0,0,0-.7-1.585l-.144.417a.892.892,0,0,0,.738-.373,1.355,1.355,0,0,0,.236-.742,1.7,1.7,0,0,0-.58-1.384c-.808-.624-1.808-.663-2.536-1.1l.07.063a11.037,11.037,0,0,0-5.53-3.919l.054.424L401.219,135l1.375-.851a11.5,11.5,0,0,0,1.38-.919,1.389,1.389,0,0,0,.44-.835,1.742,1.742,0,0,0-.143-.906,3.957,3.957,0,0,0-1.028-1.344,8.976,8.976,0,0,0-4.329-2.211,2.411,2.411,0,0,0-.878-.013,1.033,1.033,0,0,0-.791.577l.332-.109a6.672,6.672,0,0,0-3-.74c-.508-.024-1-.053-1.52-.038a2.53,2.53,0,0,0-1.54.492l.356.287c.443-.877,1.521-1.34,2.157-2.32a1.744,1.744,0,0,0,.21-1.74,1.514,1.514,0,0,0-.652-.659,1.041,1.041,0,0,0-.98-.005l.194.421a1.049,1.049,0,0,0,.623-.671,1.551,1.551,0,0,0,.016-.859,1.5,1.5,0,0,0-.437-.737,2.207,2.207,0,0,0-.7-.425,5.753,5.753,0,0,0-1.5-.3,2.548,2.548,0,0,0-.8.037.957.957,0,0,0-.717.569l.445.056a1.66,1.66,0,0,0-3.01-.508l.381-.049a1.992,1.992,0,0,0-2.9-.022l.309-.032a2.513,2.513,0,0,0-3.124.267l.342.3,1.513-2.1a2.953,2.953,0,0,0,.63-1.215,1.558,1.558,0,0,0,0-.746.733.733,0,0,0-.246-.383.705.705,0,0,0-.443-.139l-.017.451a1.542,1.542,0,0,0,1.464-.9,1.908,1.908,0,0,0,.067-1.7,2.96,2.96,0,0,0-2.811-1.445l-.1,0-.065.077-1.015,1.231.314-.03a2.289,2.289,0,0,0-3.7,2.241l.39-.183a1.07,1.07,0,0,0-1.052-.347,1.463,1.463,0,0,0-.9.552,3.314,3.314,0,0,0-.479,1.856l.373-.143a1.984,1.984,0,0,0-3.228,1.377l.332-.189a5.979,5.979,0,0,0-3.046-.907l.168.343a2.246,2.246,0,0,0-2.639-3.427l.291.2a2.21,2.21,0,0,0-2.708-2.047l.264.165a2.474,2.474,0,0,0-.829-1.4,2.113,2.113,0,0,0-1.525-.554,1.623,1.623,0,0,0-1.307.97,2.764,2.764,0,0,0-.124,1.569,13.036,13.036,0,0,0,1.01,2.782l1.138,2.642.294-.247-3.81-2.481-1.865-1.213a4.814,4.814,0,0,0-1.006-.576.9.9,0,0,0-.665.1c-.178.1-.32.207-.458.266a2.877,2.877,0,0,1-1,.082,1.423,1.423,0,0,0-1.078.525,2.359,2.359,0,0,0-.219,2.22,4.1,4.1,0,0,0,1.414,1.651,13.3,13.3,0,0,1,1.574,1.3l.115-.308-2.92.3.2.155a3.123,3.123,0,0,0-3.849-2.456l.22.121a2.01,2.01,0,0,0-1.486-1.3,7.227,7.227,0,0,0-1.88-.24,5.332,5.332,0,0,0-1.863.207,2.3,2.3,0,0,0-1.4,1.241,3.4,3.4,0,0,0,.606,3.434,9.791,9.791,0,0,0,2.684,2.087l-.068-.179a1.2,1.2,0,0,1-1.016.743,2.973,2.973,0,0,1-1.38-.116,9.822,9.822,0,0,0-1.415-.35,2.179,2.179,0,0,0-1.448.278c-.843.513-1.336,1.349-2.1,1.712a11.853,11.853,0,0,1-1.272.329,1.7,1.7,0,0,0-.863,1.063q-.391,1.229-.765,2.407a1.489,1.489,0,0,0,.1,1.279,1.7,1.7,0,0,0,1.052.684,2.769,2.769,0,0,0,1.209.019,5.606,5.606,0,0,0,1.088-.409,5.8,5.8,0,0,1,2.018-.708l-.049-.222a13.717,13.717,0,0,0-2.392,1.147,4.445,4.445,0,0,0-1.678,1.791,3.274,3.274,0,0,0-.163,2.251,2.02,2.02,0,0,0,1.45,1.444l-.023-.01a3.515,3.515,0,0,0,1.98.558l-.083-.094a17.375,17.375,0,0,1-1.649,5.423l.052-.033a10.25,10.25,0,0,0-2.737.333,3.842,3.842,0,0,0-1.656.97,2.606,2.606,0,0,0-.586.965,1.608,1.608,0,0,0-.085.359,2.758,2.758,0,0,1,.714-1.281,3.815,3.815,0,0,1,1.639-.927,10.348,10.348,0,0,1,2.714-.3h.035l.017-.033a17.247,17.247,0,0,0,1.706-5.452l.013-.095h-.1a3.351,3.351,0,0,1-1.881-.543l-.014-.008-.009,0a1.834,1.834,0,0,1-1.315-1.329,3.078,3.078,0,0,1,.166-2.111,4.252,4.252,0,0,1,1.61-1.693,13.59,13.59,0,0,1,2.359-1.115l.675-.266-.725.043a5.976,5.976,0,0,0-2.1.718,5.355,5.355,0,0,1-1.038.388,2.516,2.516,0,0,1-1.1-.022,1.451,1.451,0,0,1-.9-.577,1.23,1.23,0,0,1-.061-1.069l.768-2.385a1.43,1.43,0,0,1,.714-.9,10.271,10.271,0,0,0,1.286-.33c.869-.422,1.368-1.269,2.13-1.715.767-.5,1.72-.165,2.636.11a3.279,3.279,0,0,0,1.515.128,1.506,1.506,0,0,0,1.258-.95l.036-.116-.1-.063a9.565,9.565,0,0,1-2.593-2.022,3.08,3.08,0,0,1-.556-3.1,1.96,1.96,0,0,1,1.207-1.06,5.021,5.021,0,0,1,1.744-.184,6.929,6.929,0,0,1,1.79.231,1.667,1.667,0,0,1,1.248,1.061l.045.174.174-.053a2.774,2.774,0,0,1,3.389,2.171l.028.172.169-.018,2.921-.292.37-.037-.254-.271a13.512,13.512,0,0,0-1.613-1.34,3.762,3.762,0,0,1-1.291-1.491,2,2,0,0,1,.163-1.85,1.036,1.036,0,0,1,.8-.379,3.041,3.041,0,0,0,1.139-.112c.383-.187.625-.434.874-.347a5.035,5.035,0,0,1,.888.527q.924.6,1.861,1.217l3.805,2.487.556.363-.262-.61q-.563-1.311-1.134-2.643a12.839,12.839,0,0,1-.978-2.69,2.368,2.368,0,0,1,.1-1.333,1.206,1.206,0,0,1,.968-.725,2,2,0,0,1,1.9,1.609l.042.231.222-.066a1.8,1.8,0,0,1,2.169,1.644v.315l.292-.119a1.819,1.819,0,0,1,2.137,2.777l-.253.336.421.008a5.554,5.554,0,0,1,2.824.845l.349.219-.018-.407a1.555,1.555,0,0,1,2.484-1.059l.349.353.025-.5a2.941,2.941,0,0,1,.395-1.616c.275-.4.99-.553,1.256-.195l.61.821-.221-1a1.845,1.845,0,0,1,2.987-1.8l.171.144.143-.173,1.017-1.23-.164.081a2.52,2.52,0,0,1,2.388,1.193c.4.767-.211,2.029-1.084,1.947l-.015.452c.142.008.2.045.245.195a1.14,1.14,0,0,1-.01.526,2.514,2.514,0,0,1-.557,1.045q-.753,1.048-1.514,2.1l.341.3a2.06,2.06,0,0,1,2.537-.234l.171.129.138-.161a1.542,1.542,0,0,1,2.21.018l.236.281.146-.331a1.211,1.211,0,0,1,2.137.361l.1,1.155.343-1.1c.091-.293.6-.357,1.044-.309a5.323,5.323,0,0,1,1.37.271,1.275,1.275,0,0,1,.853.847c.108.4-.016.868-.35.978l.194.42c.317-.195.8.079.992.47a1.29,1.29,0,0,1-.187,1.276c-.515.843-1.6,1.294-2.181,2.358l-.548,1.012.9-.725c.679-.544,1.766-.368,2.736-.346a6.234,6.234,0,0,1,2.792.678l.238.138.095-.247c.125-.33.69-.382,1.152-.29a8.51,8.51,0,0,1,4.1,2.094,3.5,3.5,0,0,1,.913,1.181,1.013,1.013,0,0,1-.188,1.22,11.814,11.814,0,0,1-1.3.86l-1.374.851-1.814,1.121-.439.272.494.153a10.577,10.577,0,0,1,5.293,3.75l.03.04.041.023c.873.492,1.844.541,2.48,1.058a1.245,1.245,0,0,1,.4,1c-.013.38-.2.685-.505.667l-.741-.043.6.462a1.455,1.455,0,0,1,.526,1.2,1.274,1.274,0,0,1-.639,1.052l-.043.026-.026.041a2.447,2.447,0,0,1-1.372.955l-.072.023-.044.059a1.844,1.844,0,0,1-1.565.726l-.7-.066.527.471a7.081,7.081,0,0,1,2.072,2.707,2.986,2.986,0,0,1-.351,2.982l-.039.043-.013.058a1.5,1.5,0,0,1-.65.952l-.187.109.1.193a1.241,1.241,0,0,1,.121.813l-.042.193.188.071a3.723,3.723,0,0,1,2.006,1.874,3.5,3.5,0,0,1,.141,2.693,3.425,3.425,0,0,1-1.69,1.994,2.133,2.133,0,0,1-1.243.107.831.831,0,0,1-.721-.717l-.053-.89-.379.809a2.794,2.794,0,0,1-2.108,1.536l-.335.04.167.3a2.7,2.7,0,0,1-1.4,3.688l-.393.123.323.263a2.7,2.7,0,0,1,.778,2.662,2.66,2.66,0,0,1-1.679,2.033l-.219.068.076.216a2.158,2.158,0,1,1-4.078,1.415l-.163-.487-.236.457a4.725,4.725,0,0,1-1.746,2.167,1.527,1.527,0,0,1-2.1-.552l-.206-.615-.2.622a3.06,3.06,0,0,1-4.471,1.45l-.347-.257.012.432a1.9,1.9,0,0,1-3.786.335l-.024-.174h-.177l-5.473-.048a13.6,13.6,0,0,1-5.182-.731,9.657,9.657,0,0,1-2.236-1.245,9.268,9.268,0,0,0-1.071-.781,1.929,1.929,0,0,0-1.38-.16,12.726,12.726,0,0,1-2.461.546,8.711,8.711,0,0,1-2.446-.14,8.524,8.524,0,0,1-4.223-2.16,4.683,4.683,0,0,0-.968-.788,2.774,2.774,0,0,0-1.232-.286,18.9,18.9,0,0,1-2.339-.14,15.584,15.584,0,0,1-2.245-.458,5.335,5.335,0,0,1-1.974-.947,1.93,1.93,0,0,1-.769-1.81,1.38,1.38,0,0,1,1.231-1.3l.15,0,.018-.149a2.868,2.868,0,0,0-.323-1.778A1.8,1.8,0,0,0,345.9,164a1.271,1.271,0,0,0-1.355,1.029,1.173,1.173,0,0,0,.881,1.384l-.068-.284a1.778,1.778,0,0,1-1.987-.12,2.013,2.013,0,0,1-.948-1.753,2.845,2.845,0,0,1,2.8-2.45h.188l-.051-.18a6.683,6.683,0,0,1-.09-3.229l.133-.586-.374.472a2.3,2.3,0,0,1-3.115.359l-.109-.092-.08.122a4.411,4.411,0,0,1-2,1.725,2.637,2.637,0,0,1-2.412-.21,1.758,1.758,0,0,1-.835-2,1.6,1.6,0,0,1,1.588-1.228l.211.026-.109-.188a2.059,2.059,0,0,1,1.817-2.967l.12.012-.02-.121a3.282,3.282,0,0,1,1.983-3.47l-.07-.14a1.7,1.7,0,0,1-2.4-.921l-.038-.147-.081.131a1.641,1.641,0,0,1-1.334.714,3.605,3.605,0,0,1-1.373-.219,4.233,4.233,0,0,1-1.8-1.193,1.93,1.93,0,0,1-.436-1.215C334.535,146.968,334.577,146.82,334.564,146.818Z",
    transform: "translate(-334.5 -112.35)",
    fill: "#455a64"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17559",
    "data-name": "Grupo 17559",
    transform: "translate(13.739 20.625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17558",
    "data-name": "Grupo 17558"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17557",
    "data-name": "Grupo 17557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12866",
    "data-name": "Trazado 12866",
    d: "M384.1,150.69a17.388,17.388,0,0,0-17.056-18.322,17.9,17.9,0,0,0-18.138,16.359c-.714,8.1-1.251,16.258-1.023,19.194.688,8.856,6.192,11.966,8.4,12.863a11.848,11.848,0,0,0,2.413.427h0a.06.06,0,0,1,.055.066l-1.347,10.3c-.478,6.724-1.954,29.592,4.887,30.124,6.862.534,17.5-22.1,18.1-28.833Z",
    transform: "translate(-347.83 -132.361)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17568",
    "data-name": "Grupo 17568",
    transform: "translate(17.482 42.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17567",
    "data-name": "Grupo 17567"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17566",
    "data-name": "Grupo 17566"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17565",
    "data-name": "Grupo 17565"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17564",
    "data-name": "Grupo 17564"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17563",
    "data-name": "Grupo 17563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17562",
    "data-name": "Grupo 17562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12867",
    "data-name": "Trazado 12867",
    d: "M351.47,154.5a1.414,1.414,0,0,0,1.264,1.528,1.377,1.377,0,0,0,1.583-1.154,1.417,1.417,0,0,0-1.263-1.529A1.376,1.376,0,0,0,351.47,154.5Z",
    transform: "translate(-351.461 -153.331)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17577",
    "data-name": "Grupo 17577",
    transform: "translate(17.036 37.987)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17576",
    "data-name": "Grupo 17576"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17575",
    "data-name": "Grupo 17575"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17574",
    "data-name": "Grupo 17574"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17573",
    "data-name": "Grupo 17573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17572",
    "data-name": "Grupo 17572"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17571",
    "data-name": "Grupo 17571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17570",
    "data-name": "Grupo 17570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12868",
    "data-name": "Trazado 12868",
    d: "M351.046,150.479c.162.2,1.313-.507,2.855-.383,1.542.1,2.609.97,2.791.8.089-.076-.064-.422-.528-.812a3.975,3.975,0,0,0-2.216-.866,3.85,3.85,0,0,0-2.291.535C351.153,150.071,350.965,150.39,351.046,150.479Z",
    transform: "translate(-351.028 -149.205)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17586",
    "data-name": "Grupo 17586",
    transform: "translate(31.891 43.386)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17585",
    "data-name": "Grupo 17585"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17584",
    "data-name": "Grupo 17584"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17583",
    "data-name": "Grupo 17583"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17582",
    "data-name": "Grupo 17582"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17581",
    "data-name": "Grupo 17581"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17580",
    "data-name": "Grupo 17580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12869",
    "data-name": "Trazado 12869",
    d: "M365.449,155.612a1.416,1.416,0,0,0,1.265,1.528,1.375,1.375,0,0,0,1.582-1.154,1.415,1.415,0,0,0-1.263-1.529A1.377,1.377,0,0,0,365.449,155.612Z",
    transform: "translate(-365.44 -154.443)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17595",
    "data-name": "Grupo 17595",
    transform: "translate(32.169 39.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17594",
    "data-name": "Grupo 17594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17593",
    "data-name": "Grupo 17593"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17592",
    "data-name": "Grupo 17592"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17591",
    "data-name": "Grupo 17591"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17590",
    "data-name": "Grupo 17590"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17589",
    "data-name": "Grupo 17589"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17588",
    "data-name": "Grupo 17588"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12870",
    "data-name": "Trazado 12870",
    d: "M365.728,151.9c.163.2,1.315-.507,2.856-.383,1.542.1,2.609.97,2.791.8.089-.076-.063-.422-.528-.812a3.974,3.974,0,0,0-2.216-.865,3.843,3.843,0,0,0-2.291.534C365.837,151.49,365.647,151.809,365.728,151.9Z",
    transform: "translate(-365.71 -150.625)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17604",
    "data-name": "Grupo 17604",
    transform: "translate(21.815 38.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17603",
    "data-name": "Grupo 17603"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17602",
    "data-name": "Grupo 17602"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17601",
    "data-name": "Grupo 17601"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17600",
    "data-name": "Grupo 17600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17599",
    "data-name": "Grupo 17599"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17598",
    "data-name": "Grupo 17598"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12871",
    "data-name": "Trazado 12871",
    d: "M359.508,162.711a10.384,10.384,0,0,0-2.469-.639c-.39-.071-.757-.176-.8-.445a1.957,1.957,0,0,1,.359-1.127q.671-1.361,1.409-2.854c1.966-4.067,3.422-7.424,3.255-7.5s-1.9,3.159-3.862,7.227q-.711,1.5-1.362,2.876a2.216,2.216,0,0,0-.33,1.5.977.977,0,0,0,.6.616,2.738,2.738,0,0,0,.661.143A10.259,10.259,0,0,0,359.508,162.711Z",
    transform: "translate(-355.665 -150.144)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17612",
    "data-name": "Grupo 17612",
    transform: "translate(24.304 66.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17611",
    "data-name": "Grupo 17611"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17610",
    "data-name": "Grupo 17610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17609",
    "data-name": "Grupo 17609"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17608",
    "data-name": "Grupo 17608"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17607",
    "data-name": "Grupo 17607"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12872",
    "data-name": "Trazado 12872",
    d: "M358.442,179.846s5.914.943,13.726-2.874c-.471.233-2.729,8.937-14.089,5.65Z",
    transform: "translate(-358.079 -176.972)",
    fill: "#eb996e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17620",
    "data-name": "Grupo 17620",
    transform: "translate(25.825 54.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17619",
    "data-name": "Grupo 17619"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17618",
    "data-name": "Grupo 17618"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17617",
    "data-name": "Grupo 17617"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17616",
    "data-name": "Grupo 17616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17615",
    "data-name": "Grupo 17615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12873",
    "data-name": "Trazado 12873",
    d: "M359.736,165.953a2.823,2.823,0,0,1,2.575-.819,2.538,2.538,0,0,1,1.675,1.059,1.561,1.561,0,0,1-.027,1.815,1.9,1.9,0,0,1-2.064.345,5.835,5.835,0,0,1-1.875-1.309,1.677,1.677,0,0,1-.4-.482.5.5,0,0,1,.048-.564",
    transform: "translate(-359.555 -165.085)",
    fill: "#eb996e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17629",
    "data-name": "Grupo 17629",
    transform: "translate(24.859 52.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17628",
    "data-name": "Grupo 17628"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17627",
    "data-name": "Grupo 17627"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17626",
    "data-name": "Grupo 17626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17625",
    "data-name": "Grupo 17625"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17624",
    "data-name": "Grupo 17624"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17623",
    "data-name": "Grupo 17623"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12874",
    "data-name": "Trazado 12874",
    d: "M363.867,163.7c-.249-.034-.39,1.61-1.919,2.665s-3.3.736-3.328.965c-.032.1.371.35,1.122.429a4.243,4.243,0,0,0,2.771-.712,3.584,3.584,0,0,0,1.5-2.243C364.135,164.117,363.983,163.7,363.867,163.7Z",
    transform: "translate(-358.618 -163.695)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17637",
    "data-name": "Grupo 17637",
    transform: "translate(32.232 34.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17636",
    "data-name": "Grupo 17636"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17635",
    "data-name": "Grupo 17635"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12875",
    "data-name": "Trazado 12875",
    d: "M365.775,147.132c.119.424,1.674.348,3.465.7,1.8.32,3.215.953,3.485.6.122-.168-.1-.575-.657-1.02a5.922,5.922,0,0,0-2.529-1.1,5.986,5.986,0,0,0-2.765.1C366.087,146.633,365.727,146.931,365.775,147.132Z",
    transform: "translate(-365.771 -146.208)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17645",
    "data-name": "Grupo 17645",
    transform: "translate(17.812 33.913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17644",
    "data-name": "Grupo 17644"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17643",
    "data-name": "Grupo 17643"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12876",
    "data-name": "Trazado 12876",
    d: "M351.811,146.625c.243.366,1.335.091,2.613.174,1.282.038,2.341.414,2.619.074.124-.167-.018-.525-.464-.886a3.846,3.846,0,0,0-4.216-.2C351.883,146.105,351.7,146.449,351.811,146.625Z",
    transform: "translate(-351.781 -145.253)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17734",
    "data-name": "Grupo 17734",
    transform: "translate(4.878 8.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17658",
    "data-name": "Grupo 17658",
    transform: "translate(6.855 7.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17657",
    "data-name": "Grupo 17657"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12877",
    "data-name": "Trazado 12877",
    d: "M346.6,138.173a11,11,0,0,1,.219-1.47,4.474,4.474,0,0,1,1.307-1.837c1.873-1.838,3.85-3.737,6.207-4.347,1.44-.372,2.934-.233,4.377-.591a25.22,25.22,0,0,0,2.618-.951,21.446,21.446,0,0,1,11.117-.6,17.693,17.693,0,0,1,5.972,1.938,21.4,21.4,0,0,1,5.352,4.871,32.609,32.609,0,0,1,5.966,9.6,15.953,15.953,0,0,1,.859,9.069c-.71,3.022-2.847,5.733-5.463,6.151l-.911-1.241-1.455-1.84c.241.734,0,.679-.613,1.029a1.251,1.251,0,0,1-1.73-.643c-.526.6-1.555-.143-1.337-.96-.612.278-1.313-.573-1.063-1.291-.7.2-1.012-.929-1.307-1.692a11.581,11.581,0,0,0-.6-1.176,7.634,7.634,0,0,1-.773-4.176,7.478,7.478,0,0,1-.949-4.105q-.053-1.362-.105-2.722-.226-.334-.449-.668a1.471,1.471,0,0,1-1.087,1.318,3.139,3.139,0,0,1-1.631-.162l-1.583-.445-1.029.208a4.077,4.077,0,0,1-.513,2.6,2.532,2.532,0,0,1-1.05,1.386.764.764,0,0,1-.995-.9.846.846,0,0,1-1.288-.313,2.78,2.78,0,0,1-.227-1.689,7.118,7.118,0,0,1,1.611-3.8l-3.011,2.392a1.316,1.316,0,0,1-.719.364.742.742,0,0,1-.854.752,1.928,1.928,0,0,1-.978-.786c-.623-.772-1.244-2.048-.571-2.8a.609.609,0,0,1-.2-.909l-3.371,2.156c.331-.159.641.363.538.768a1.692,1.692,0,0,1-.739.886,2.485,2.485,0,0,1,.242,1.536c.613-.467,1.394.555,1.142,1.36a1.8,1.8,0,0,1-1.785,1.173,1.253,1.253,0,0,1-1.339-1.041c-.709.091-1.3-.922-.989-1.689-.531.3-.9-.646-.871-1.333a9.881,9.881,0,0,1,.8-3.493.183.183,0,0,1-.262.053.206.206,0,0,1-.058-.138q-1,1.97-2.009,3.939a10.258,10.258,0,0,0-1.278,3.552c-.053.521-.17,1.23-.611,1.241a.651.651,0,0,1-.337-.119,6.556,6.556,0,0,1-2.589-3.563,4.984,4.984,0,0,1-.312-1.571A21.3,21.3,0,0,1,346.6,138.173Z",
    transform: "translate(-345.883 -127.932)",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17671",
    "data-name": "Grupo 17671",
    transform: "translate(42.532 35.153)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17670",
    "data-name": "Grupo 17670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17669",
    "data-name": "Grupo 17669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17668",
    "data-name": "Grupo 17668"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17667",
    "data-name": "Grupo 17667"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17666",
    "data-name": "Grupo 17666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17665",
    "data-name": "Grupo 17665"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17664",
    "data-name": "Grupo 17664"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17663",
    "data-name": "Grupo 17663"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17662",
    "data-name": "Grupo 17662"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17661",
    "data-name": "Grupo 17661"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17660",
    "data-name": "Grupo 17660"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17659",
    "data-name": "Grupo 17659"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12878",
    "data-name": "Trazado 12878",
    d: "M381.388,155.172c.155-.056,6.187-1.414,5.614,4.619s-6.511,4.212-6.5,4.038S381.388,155.172,381.388,155.172Z",
    transform: "translate(-380.497 -155.003)",
    fill: "#ffbe9d"
  })))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17685",
    "data-name": "Grupo 17685",
    transform: "translate(44.584 37.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17684",
    "data-name": "Grupo 17684"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17683",
    "data-name": "Grupo 17683"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17682",
    "data-name": "Grupo 17682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17681",
    "data-name": "Grupo 17681"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17680",
    "data-name": "Grupo 17680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17679",
    "data-name": "Grupo 17679"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17678",
    "data-name": "Grupo 17678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17677",
    "data-name": "Grupo 17677"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17676",
    "data-name": "Grupo 17676"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17675",
    "data-name": "Grupo 17675"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17674",
    "data-name": "Grupo 17674"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17673",
    "data-name": "Grupo 17673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17672",
    "data-name": "Grupo 17672"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12879",
    "data-name": "Trazado 12879",
    d: "M382.5,161.657c.029-.017.1.083.268.182a1.062,1.062,0,0,0,.784.091,2.615,2.615,0,0,0,1.424-2.219,3.478,3.478,0,0,0-.152-1.533,1.219,1.219,0,0,0-.713-.881.537.537,0,0,0-.647.229c-.1.161-.07.286-.1.293s-.121-.113-.048-.358a.674.674,0,0,1,.274-.356.8.8,0,0,1,.6-.1,1.482,1.482,0,0,1,1.008,1.04,3.581,3.581,0,0,1,.205,1.716,2.741,2.741,0,0,1-1.781,2.459,1.13,1.13,0,0,1-.945-.251C382.492,161.8,382.474,161.666,382.5,161.657Z",
    transform: "translate(-382.488 -156.988)",
    fill: "#eb996e"
  }))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17689",
    "data-name": "Grupo 17689",
    transform: "translate(21.068 11.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17688",
    "data-name": "Grupo 17688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17687",
    "data-name": "Grupo 17687"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17686",
    "data-name": "Grupo 17686"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12880",
    "data-name": "Trazado 12880",
    d: "M360.158,136.683a1.508,1.508,0,0,1-.339-.811,1.069,1.069,0,0,1,.349-.885,1.145,1.145,0,0,1,1.18-.2l.244.106-.088-.253a1.2,1.2,0,0,1,.433-1.31,1.173,1.173,0,0,1,1.5.181l.215-.169a.515.515,0,0,1-.07-.159.676.676,0,0,1,.145-.56.777.777,0,0,1,.517-.269,1.289,1.289,0,0,1,.6.079,1.647,1.647,0,0,0,.664.208c.294-.028.44-.231.6-.314a2.276,2.276,0,0,1,.492-.249,2.607,2.607,0,0,1,.988-.139,2.651,2.651,0,0,1,1.377.46c.288.2.413.357.433.34a1.19,1.19,0,0,0-.368-.426,2.592,2.592,0,0,0-1.428-.567,2.718,2.718,0,0,0-1.075.116,2.473,2.473,0,0,0-.551.263c-.186.111-.33.265-.478.264a1.594,1.594,0,0,1-.555-.2,1.542,1.542,0,0,0-.729-.1,1.046,1.046,0,0,0-.7.364.944.944,0,0,0-.2.795.776.776,0,0,0,.112.254l.215-.17a1.391,1.391,0,0,0-2.354,1.388l.156-.146a1.337,1.337,0,0,0-1.4.272,1.249,1.249,0,0,0-.076,1.684C360.074,136.651,360.153,136.691,360.158,136.683Z",
    transform: "translate(-359.673 -131.737)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17693",
    "data-name": "Grupo 17693",
    transform: "translate(14.037 8.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17692",
    "data-name": "Grupo 17692"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17691",
    "data-name": "Grupo 17691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17690",
    "data-name": "Grupo 17690"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12881",
    "data-name": "Trazado 12881",
    d: "M353.476,137.93a1.861,1.861,0,0,1-.449-.8,1.36,1.36,0,0,1,.149-1.017,1.417,1.417,0,0,1,1.128-.681l.2-.008-.12-.16a1.692,1.692,0,0,1-.335-1.514.909.909,0,0,1,.595-.563.72.72,0,0,1,.792.174l.7.884-.478-1.022a1.4,1.4,0,0,1,.026-1.185,1.3,1.3,0,0,1,1-.719,1.37,1.37,0,0,1,.895.168l.3.181-.1-.339c-.144-.48.374-.979.849-1a2.31,2.31,0,0,1,1.4.48l.248.162-.058-.289a1,1,0,0,1,.409-.936,1.838,1.838,0,0,1,.961-.333,4.7,4.7,0,0,1,1.731.19,7.475,7.475,0,0,1,1.411.647,1.241,1.241,0,0,0-.32-.265,4.417,4.417,0,0,0-1.046-.523,4.633,4.633,0,0,0-1.792-.254,2.034,2.034,0,0,0-1.083.356,1.225,1.225,0,0,0-.512,1.165l.19-.126a2.521,2.521,0,0,0-1.56-.538,1.268,1.268,0,0,0-.832.406.972.972,0,0,0-.257.938l.2-.158a1.639,1.639,0,0,0-1.075-.205,1.563,1.563,0,0,0-1.207.872,1.662,1.662,0,0,0-.02,1.416l.222-.139a.976.976,0,0,0-1.076-.25,1.157,1.157,0,0,0-.743.725,1.894,1.894,0,0,0,.4,1.721l.077-.168a1.585,1.585,0,0,0-1.262.806,1.5,1.5,0,0,0,.243,1.751C353.393,137.9,353.472,137.936,353.476,137.93Z",
    transform: "translate(-352.851 -129.202)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17697",
    "data-name": "Grupo 17697",
    transform: "translate(0 9.142)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17696",
    "data-name": "Grupo 17696"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17695",
    "data-name": "Grupo 17695"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17694",
    "data-name": "Grupo 17694"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12882",
    "data-name": "Trazado 12882",
    d: "M339.248,137.922a1.026,1.026,0,0,1,.414-.712,1.308,1.308,0,0,1,.928-.246,3.86,3.86,0,0,1,1.264.416l.145.068-.007-.162a1.175,1.175,0,0,1,1.049-1.058,3.409,3.409,0,0,1,1.893.473l.817.387-.677-.6a.964.964,0,0,1,.193-1.375,2.185,2.185,0,0,1,1.721-.255l.08.014.529.095-.418-.338a1.034,1.034,0,0,1,.255-1.619,1.567,1.567,0,0,1,1.722.316l.518.488-.32-.636a2.344,2.344,0,0,1,.21-2.375,2.186,2.186,0,0,1,1.689-.884,2.479,2.479,0,0,1,1.262.274c.27.143.394.259.407.244s-.023-.037-.081-.095a1.624,1.624,0,0,0-.285-.22,2.419,2.419,0,0,0-1.306-.357,2.337,2.337,0,0,0-1.854.911,2.554,2.554,0,0,0-.266,2.615l.2-.148a1.815,1.815,0,0,0-2.02-.372,1.318,1.318,0,0,0-.671.939,1.16,1.16,0,0,0,.372,1.135l.11-.243-.086-.014a2.428,2.428,0,0,0-1.938.314,1.393,1.393,0,0,0-.485.859,1,1,0,0,0,.291.917l.14-.212A3.585,3.585,0,0,0,343,136a1.377,1.377,0,0,0-1.2,1.295l.138-.094a3.925,3.925,0,0,0-1.334-.393,1.408,1.408,0,0,0-1.006.317.984.984,0,0,0-.352.565A.416.416,0,0,0,339.248,137.922Z",
    transform: "translate(-339.232 -129.768)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17701",
    "data-name": "Grupo 17701",
    transform: "translate(8.823 4.109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17700",
    "data-name": "Grupo 17700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17699",
    "data-name": "Grupo 17699"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17698",
    "data-name": "Grupo 17698"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12883",
    "data-name": "Trazado 12883",
    d: "M347.793,124.887a.8.8,0,0,0,.347.16,4.613,4.613,0,0,0,1.051.145,3.162,3.162,0,0,1,1.5.359.966.966,0,0,1,.474.707.7.7,0,0,1-.345.772l.175.148c.086-.344.537-.529.946-.726a4.556,4.556,0,0,1,1.32-.438,1.649,1.649,0,0,1,1.277.31,1.094,1.094,0,0,1,.473,1.051l-.071.331.273-.2a3.037,3.037,0,0,1,1.838-.578,3.419,3.419,0,0,1,1.5.349,4.359,4.359,0,0,1,1.1.846,1.081,1.081,0,0,0-.206-.317,2.9,2.9,0,0,0-.824-.668,3.443,3.443,0,0,0-1.571-.426,3.2,3.2,0,0,0-2,.589l.2.13a1.349,1.349,0,0,0-.559-1.318,1.907,1.907,0,0,0-1.477-.369,4.71,4.71,0,0,0-1.4.466,5.736,5.736,0,0,0-.623.33,1,1,0,0,0-.458.579l-.06.254.234-.105a.943.943,0,0,0,.482-1.044,1.2,1.2,0,0,0-.6-.854,3.17,3.17,0,0,0-1.609-.332,6.026,6.026,0,0,1-1.038-.07C347.923,124.922,347.8,124.872,347.793,124.887Z",
    transform: "translate(-347.793 -124.884)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17705",
    "data-name": "Grupo 17705",
    transform: "translate(22.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17704",
    "data-name": "Grupo 17704"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17703",
    "data-name": "Grupo 17703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17702",
    "data-name": "Grupo 17702"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12884",
    "data-name": "Trazado 12884",
    d: "M361.314,120.945a2.89,2.89,0,0,1,.705.161,1.731,1.731,0,0,1,.644.49,1.494,1.494,0,0,1,.356.952v.148l.143-.036a.9.9,0,0,1,.947.645,2.74,2.74,0,0,1-.077,1.506l-.128.526.369-.409.058-.064a1.16,1.16,0,0,1,.968-.306,1.294,1.294,0,0,1,.857.463,2.063,2.063,0,0,1,.409,1.654,3.845,3.845,0,0,1-.405,1.15,1.973,1.973,0,0,0-.2.412c.013.009.129-.109.3-.359a3.361,3.361,0,0,0,.5-1.169,2.223,2.223,0,0,0-.406-1.851,1.523,1.523,0,0,0-2.216-.186l-.074.083.24.118a2.9,2.9,0,0,0,.056-1.66,1.132,1.132,0,0,0-1.247-.778l.143.112a1.66,1.66,0,0,0-.445-1.075,1.775,1.775,0,0,0-.738-.492,1.419,1.419,0,0,0-.559-.08C361.379,120.914,361.313,120.935,361.314,120.945Z",
    transform: "translate(-361.314 -120.898)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17709",
    "data-name": "Grupo 17709",
    transform: "translate(33.941 2.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17708",
    "data-name": "Grupo 17708"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17707",
    "data-name": "Grupo 17707"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17706",
    "data-name": "Grupo 17706"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12885",
    "data-name": "Trazado 12885",
    d: "M372.163,130.163a.732.732,0,0,0,.365-.051,2.271,2.271,0,0,0,.871-.51,2.428,2.428,0,0,0,.739-1.312,1.239,1.239,0,0,1,.243-.726c.171-.178.513-.27.745-.568a1.37,1.37,0,0,0-.193-1.868l-.005.2a4.392,4.392,0,0,0,1.3-1.517,1.784,1.784,0,0,0,.255-.727c-.03-.011-.134.25-.385.652a4.845,4.845,0,0,1-1.315,1.387l-.138.1.133.1a1.13,1.13,0,0,1,.133,1.5c-.159.223-.464.3-.719.548a1.43,1.43,0,0,0-.3.873,2.331,2.331,0,0,1-.626,1.217A3.46,3.46,0,0,1,372.163,130.163Z",
    transform: "translate(-372.162 -123.085)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17713",
    "data-name": "Grupo 17713",
    transform: "translate(37.239 8.478)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17712",
    "data-name": "Grupo 17712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17711",
    "data-name": "Grupo 17711"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17710",
    "data-name": "Grupo 17710"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12886",
    "data-name": "Trazado 12886",
    d: "M375.362,132.673c0,.011.075.031.224.052a3.072,3.072,0,0,0,.651,0,3.64,3.64,0,0,0,2.11-.969l-.176-.019a2.349,2.349,0,0,0,1.529.983,2.419,2.419,0,0,0,1.026-.033,1.491,1.491,0,0,0,.926-.6,3.166,3.166,0,0,0,.142-.383.54.54,0,0,1,.192-.238,1.689,1.689,0,0,1,.652-.225,2.184,2.184,0,0,0,.726-.227.779.779,0,0,0,.444-.637l-.182.105a2.41,2.41,0,0,0,1.658.181,2.61,2.61,0,0,0,1.15-.591,2.175,2.175,0,0,0,.511-.662.738.738,0,0,0,.092-.282,3.4,3.4,0,0,1-.7.83,2.562,2.562,0,0,1-1.1.5,2.236,2.236,0,0,1-1.5-.2l-.176-.093-.006.2a.531.531,0,0,1-.323.419,1.958,1.958,0,0,1-.648.191,1.914,1.914,0,0,0-.762.266.813.813,0,0,0-.287.356,3.6,3.6,0,0,1-.129.355,1.262,1.262,0,0,1-.754.475,2.2,2.2,0,0,1-.91.036,2.137,2.137,0,0,1-1.383-.852l-.078-.115-.1.1a3.691,3.691,0,0,1-1.967,1C375.682,132.682,375.364,132.641,375.362,132.673Z",
    transform: "translate(-375.362 -129.123)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17717",
    "data-name": "Grupo 17717",
    transform: "translate(42.197 13.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17716",
    "data-name": "Grupo 17716"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17715",
    "data-name": "Grupo 17715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17714",
    "data-name": "Grupo 17714"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12887",
    "data-name": "Trazado 12887",
    d: "M396,142.745c.005,0,.019-.029.039-.091a1.563,1.563,0,0,0,.07-.28,2.9,2.9,0,0,0-.038-1.094,6.423,6.423,0,0,0-.6-1.592,6.013,6.013,0,0,0-.531-.914,1.624,1.624,0,0,0-.443-.407.726.726,0,0,0-.668-.056l.162.127a1.82,1.82,0,0,0-2.819-1.832l.21.127a1.253,1.253,0,0,0-.418-1.065,1.2,1.2,0,0,0-1.15-.242,1.238,1.238,0,0,0-.57.36l.238.113a.784.784,0,0,0-.232-.666,1.073,1.073,0,0,0-.594-.309,2.473,2.473,0,0,0-1.191.2l.162.066a1.954,1.954,0,0,0-1.109-.926,2.735,2.735,0,0,0-1.336-.113,6.883,6.883,0,0,0-2.142.846l.133.135a.48.48,0,0,0-.014-.478.826.826,0,0,0-.314-.286,1.4,1.4,0,0,0-.717-.172,3.919,3.919,0,0,0-1.113.235,3.635,3.635,0,0,0-.645.309.742.742,0,0,0-.2.149c.013.024.3-.171.88-.355a4.1,4.1,0,0,1,1.082-.182,1.258,1.258,0,0,1,.624.17c.2.111.361.322.243.515l-.174.288.308-.153a6.888,6.888,0,0,1,2.085-.786,2.513,2.513,0,0,1,1.215.117,1.7,1.7,0,0,1,.958.8l.052.1.11-.038a2.251,2.251,0,0,1,1.061-.181c.324.046.653.355.6.663l-.084.476.323-.364a.974.974,0,0,1,.442-.277.931.931,0,0,1,.891.183.987.987,0,0,1,.332.83l-.034.295.244-.168a1.607,1.607,0,0,1,1.809.021,1.628,1.628,0,0,1,.63,1.546l-.04.224.2-.1c.306-.147.64.121.849.383a6.015,6.015,0,0,1,.53.87,6.711,6.711,0,0,1,.637,1.535A3.676,3.676,0,0,1,396,142.745Z",
    transform: "translate(-380.172 -134.113)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17721",
    "data-name": "Grupo 17721",
    transform: "translate(43.103 18.874)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17720",
    "data-name": "Grupo 17720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17719",
    "data-name": "Grupo 17719"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17718",
    "data-name": "Grupo 17718"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12888",
    "data-name": "Trazado 12888",
    d: "M393.768,150.441c.007.005.06-.049.152-.161a4.378,4.378,0,0,0,.368-.521,1.962,1.962,0,0,0,.3-.979,1.43,1.43,0,0,0-.154-.642,1.028,1.028,0,0,0-.558-.51l.043.152a1.277,1.277,0,0,0-1.192-2.069l.11.2a1.027,1.027,0,0,0,.063-1.216,1.518,1.518,0,0,0-1.116-.642,5.834,5.834,0,0,1-.609-.055.524.524,0,0,1-.349-.359,2.236,2.236,0,0,0-.3-.618,1.179,1.179,0,0,0-.612-.409,6.748,6.748,0,0,0-1.45-.16,1.578,1.578,0,0,1-1.146-.442,6.186,6.186,0,0,1-.33-.553,1.36,1.36,0,0,0-.514-.472,1.439,1.439,0,0,0-1.282-.04l.146.182a1.088,1.088,0,0,0-.041-1.269,1.532,1.532,0,0,0-.977-.593,4.851,4.851,0,0,0-1.8.069,5.906,5.906,0,0,0-1.1.335,1.369,1.369,0,0,0-.365.187,13.629,13.629,0,0,1,1.495-.383,4.961,4.961,0,0,1,1.734-.015,1.341,1.341,0,0,1,.838.525.866.866,0,0,1,.035,1l-.326.4.471-.221a1.2,1.2,0,0,1,1.059.048,1.122,1.122,0,0,1,.414.388,5.345,5.345,0,0,0,.343.58,1.419,1.419,0,0,0,.616.415,3.188,3.188,0,0,0,.714.132,6.8,6.8,0,0,1,1.388.149.915.915,0,0,1,.479.317,2.028,2.028,0,0,1,.268.557.8.8,0,0,0,.529.512,4.881,4.881,0,0,0,.646.058,1.269,1.269,0,0,1,.931.514.782.782,0,0,1-.025.914l-.239.261.348-.057a1.082,1.082,0,0,1,1.121.575,1.107,1.107,0,0,1-.118,1.131l-.086.107.13.044a1.043,1.043,0,0,1,.62.973,1.916,1.916,0,0,1-.243.925C393.936,150.185,393.746,150.426,393.768,150.441Z",
    transform: "translate(-381.051 -139.21)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17725",
    "data-name": "Grupo 17725",
    transform: "translate(53.314 31.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17724",
    "data-name": "Grupo 17724"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17723",
    "data-name": "Grupo 17723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17722",
    "data-name": "Grupo 17722"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12889",
    "data-name": "Trazado 12889",
    d: "M394.314,164.86a.609.609,0,0,0,.272-.063,1.893,1.893,0,0,0,.665-.437,1.952,1.952,0,0,0,.558-1.115,2.081,2.081,0,0,0-.429-1.57v.146a3.782,3.782,0,0,0,.827-1.3,1.547,1.547,0,0,0,.011-.877,1.124,1.124,0,0,0-.587-.731l.006.242a1.589,1.589,0,0,0,.8-1.365,1.775,1.775,0,0,0-.205-.913,1.489,1.489,0,0,0-.658-.624.517.517,0,0,1-.344-.534,2.17,2.17,0,0,0-.114-.814,2.766,2.766,0,0,0-.923-1.175c-.344-.3-.662-.576-.964-.823a4.588,4.588,0,0,0-1.6-.926,2.146,2.146,0,0,0-.5-.083c-.115,0-.175,0-.176.013,0,.027.242.025.642.172a4.893,4.893,0,0,1,1.506.972l.937.844a2.581,2.581,0,0,1,.835,1.087,1.957,1.957,0,0,1,.092.733.784.784,0,0,0,.112.462,1.05,1.05,0,0,0,.358.3,1.416,1.416,0,0,1,.071,2.43l-.245.125.252.117a1.088,1.088,0,0,1,.444,1.29,3.654,3.654,0,0,1-.758,1.22l-.06.074.059.072a1.908,1.908,0,0,1,.422,1.4,1.854,1.854,0,0,1-.47,1.047A2.727,2.727,0,0,1,394.314,164.86Z",
    transform: "translate(-390.958 -151.904)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17729",
    "data-name": "Grupo 17729",
    transform: "translate(33.795 16.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17728",
    "data-name": "Grupo 17728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17727",
    "data-name": "Grupo 17727"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17726",
    "data-name": "Grupo 17726"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12890",
    "data-name": "Trazado 12890",
    d: "M372.021,141.251a2.062,2.062,0,0,0,.835-.254,2.309,2.309,0,0,0,.787-.573,1.507,1.507,0,0,0,.367-1.162,1.149,1.149,0,0,0-.087-.295l-.073.183a1.311,1.311,0,0,0,.748-.843,1.191,1.191,0,0,0-.1-.9c-.261-.462-.61-.535-.609-.507-.026.036.263.17.442.586a1.063,1.063,0,0,1,.032.748,1.1,1.1,0,0,1-.616.662l-.126.05.053.133a.886.886,0,0,1,.064.223,1.313,1.313,0,0,1-.293.961,2.373,2.373,0,0,1-.681.561A4.141,4.141,0,0,0,372.021,141.251Z",
    transform: "translate(-372.02 -136.896)",
    fill: "#455a64"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17733",
    "data-name": "Grupo 17733",
    transform: "translate(27.416 13.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17732",
    "data-name": "Grupo 17732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17731",
    "data-name": "Grupo 17731"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17730",
    "data-name": "Grupo 17730"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12891",
    "data-name": "Trazado 12891",
    d: "M366.121,137.853a1.6,1.6,0,0,1-.106-1.013,1.134,1.134,0,0,1,.715-.8,1.225,1.225,0,0,1,1.285.314l.157.175.065-.228a2.248,2.248,0,0,1,.379-.776,1.034,1.034,0,0,1,.723-.429c.441-.022.895.425.745.774l.253.074a2.092,2.092,0,0,1,.865-1.295,2.037,2.037,0,0,1,1.207-.347,3.2,3.2,0,0,1,1.124.3c.008-.01-.071-.094-.253-.2a2.061,2.061,0,0,0-.863-.269,2.147,2.147,0,0,0-1.342.326,2.28,2.28,0,0,0-1,1.432l.254.074a.767.767,0,0,0-.2-.814,1.089,1.089,0,0,0-.8-.33,1.289,1.289,0,0,0-.927.535,2.448,2.448,0,0,0-.416.876l.222-.052a1.445,1.445,0,0,0-1.554-.348,1.294,1.294,0,0,0-.8.97,1.308,1.308,0,0,0,.09.813C366.032,137.791,366.112,137.86,366.121,137.853Z",
    transform: "translate(-365.832 -134.128)",
    fill: "#455a64"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17785",
    "data-name": "Grupo 17785",
    transform: "translate(0 330.241)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17737",
    "data-name": "Grupo 17737",
    transform: "translate(24.91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17736",
    "data-name": "Grupo 17736"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12892",
    "data-name": "Trazado 12892",
    d: "M314.015,440.66l-3.47,17.094-11.43,1.075-4.814-5.669,4.406-20.411Z",
    transform: "translate(-294.301 -432.75)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17784",
    "data-name": "Grupo 17784",
    transform: "translate(0 18.511)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17744",
    "data-name": "Grupo 17744",
    transform: "translate(0.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17743",
    "data-name": "Grupo 17743"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17742",
    "data-name": "Grupo 17742"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17741",
    "data-name": "Grupo 17741"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17740",
    "data-name": "Grupo 17740"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17739",
    "data-name": "Grupo 17739"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17738",
    "data-name": "Grupo 17738"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12893",
    "data-name": "Trazado 12893",
    d: "M292.757,450.709l-.041,1.336s-21.877,8.446-22.225,12.737l42.949,1.065-.245-14.984C306.738,453.8,300.047,453.985,292.757,450.709Z",
    transform: "translate(-270.49 -450.709)",
    fill: "#e02a58",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17752",
    "data-name": "Grupo 17752",
    transform: "translate(36.481 4.746)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17751",
    "data-name": "Grupo 17751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17750",
    "data-name": "Grupo 17750"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17749",
    "data-name": "Grupo 17749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17748",
    "data-name": "Grupo 17748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17747",
    "data-name": "Grupo 17747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17746",
    "data-name": "Grupo 17746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17745",
    "data-name": "Grupo 17745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12894",
    "data-name": "Trazado 12894",
    d: "M307.661,455.4a1.85,1.85,0,0,1,1.165,2.126,1.679,1.679,0,0,1-2,1.228A1.952,1.952,0,0,1,305.6,456.5a1.726,1.726,0,0,1,2.218-1.036",
    transform: "translate(-305.527 -455.314)",
    fill: "#fff"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17759",
    "data-name": "Grupo 17759",
    transform: "translate(0 11.534)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17758",
    "data-name": "Grupo 17758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17757",
    "data-name": "Grupo 17757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17756",
    "data-name": "Grupo 17756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17755",
    "data-name": "Grupo 17755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17754",
    "data-name": "Grupo 17754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17753",
    "data-name": "Grupo 17753"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12895",
    "data-name": "Trazado 12895",
    d: "M313.45,465.5l-.059-3.6-41.143.3s-2.319,1.2-2.1,3.534Z",
    transform: "translate(-270.133 -461.899)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17767",
    "data-name": "Grupo 17767",
    transform: "translate(22.439 1.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17766",
    "data-name": "Grupo 17766"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17765",
    "data-name": "Grupo 17765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17764",
    "data-name": "Grupo 17764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17763",
    "data-name": "Grupo 17763"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17762",
    "data-name": "Grupo 17762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17761",
    "data-name": "Grupo 17761"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17760",
    "data-name": "Grupo 17760"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12896",
    "data-name": "Trazado 12896",
    d: "M291.9,452.13c0,.22,1.048.345,2.065,1.077,1.034.7,1.544,1.669,1.74,1.586.194-.038-.09-1.358-1.334-2.222S291.863,451.927,291.9,452.13Z",
    transform: "translate(-291.903 -451.942)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17775",
    "data-name": "Grupo 17775",
    transform: "translate(17.888 3.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17774",
    "data-name": "Grupo 17774"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17773",
    "data-name": "Grupo 17773"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17772",
    "data-name": "Grupo 17772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17771",
    "data-name": "Grupo 17771"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17770",
    "data-name": "Grupo 17770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17769",
    "data-name": "Grupo 17769"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17768",
    "data-name": "Grupo 17768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12897",
    "data-name": "Trazado 12897",
    d: "M287.49,453.911c-.053.211.847.607,1.539,1.554.718.926.875,1.935,1.084,1.931.2.039.37-1.244-.511-2.4S287.5,453.7,287.49,453.911Z",
    transform: "translate(-287.488 -453.828)",
    fill: "#263238"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17783",
    "data-name": "Grupo 17783",
    transform: "translate(13.609 5.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17782",
    "data-name": "Grupo 17782"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17781",
    "data-name": "Grupo 17781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17780",
    "data-name": "Grupo 17780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17779",
    "data-name": "Grupo 17779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17778",
    "data-name": "Grupo 17778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17777",
    "data-name": "Grupo 17777"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17776",
    "data-name": "Grupo 17776"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12898",
    "data-name": "Trazado 12898",
    d: "M284.932,459.44c.19.052.506-1.039-.005-2.255s-1.481-1.719-1.574-1.539c-.123.178.5.839.9,1.845C284.685,458.486,284.724,459.413,284.932,459.44Z",
    transform: "translate(-283.337 -455.61)",
    fill: "#263238"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17834",
    "data-name": "Grupo 17834",
    transform: "translate(93.674 334.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17787",
    "data-name": "Grupo 17787",
    transform: "translate(0.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17786",
    "data-name": "Grupo 17786"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12899",
    "data-name": "Trazado 12899",
    d: "M378.385,436.53c.163.558,0,21.872,0,21.872l-6.412,3.984-8.375-5.257-1.771-20.6Z",
    transform: "translate(-361.828 -436.53)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17792",
    "data-name": "Grupo 17792",
    transform: "translate(0.018 18.736)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17791",
    "data-name": "Grupo 17791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17790",
    "data-name": "Grupo 17790"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17789",
    "data-name": "Grupo 17789"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17788",
    "data-name": "Grupo 17788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12900",
    "data-name": "Trazado 12900",
    d: "M363.022,454.708s11.407,8.479,16.928,1.139l1.443,3.556,6.487,25.341a3.449,3.449,0,0,1-1.825,4.068,3.026,3.026,0,0,1-3.319-.665c-4.692-4.674-21.871-21.96-21.7-24.306l.066-6.221a3.162,3.162,0,0,1,1.922-2.912Z",
    transform: "translate(-361.033 -454.708)",
    fill: "#e02a58",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17797",
    "data-name": "Grupo 17797",
    transform: "translate(0 25.705)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17796",
    "data-name": "Grupo 17796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17795",
    "data-name": "Grupo 17795"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17794",
    "data-name": "Grupo 17794"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17793",
    "data-name": "Grupo 17793"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12901",
    "data-name": "Trazado 12901",
    d: "M385.5,488.776l-24.47-27.307.005,1.359a3.622,3.622,0,0,0,1.16,3,265.043,265.043,0,0,0,20.558,23.011c.756.76,2.19.095,2.748-.063Z",
    transform: "translate(-361.015 -461.469)",
    fill: "#263238"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17803",
    "data-name": "Grupo 17803",
    transform: "translate(0.837 21.349)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17802",
    "data-name": "Grupo 17802"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17801",
    "data-name": "Grupo 17801"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17800",
    "data-name": "Grupo 17800"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17799",
    "data-name": "Grupo 17799"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17798",
    "data-name": "Grupo 17798"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12902",
    "data-name": "Trazado 12902",
    d: "M364.585,457.551a2.047,2.047,0,0,1,.53,2.594,1.776,1.776,0,0,1-2.451.573,2.163,2.163,0,0,1-.547-2.751,1.835,1.835,0,0,1,2.613-.3",
    transform: "translate(-361.827 -457.242)",
    fill: "#fff"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17809",
    "data-name": "Grupo 17809",
    transform: "translate(17.396 35.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17808",
    "data-name": "Grupo 17808"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17807",
    "data-name": "Grupo 17807"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17806",
    "data-name": "Grupo 17806"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17805",
    "data-name": "Grupo 17805"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17804",
    "data-name": "Grupo 17804"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12903",
    "data-name": "Trazado 12903",
    d: "M377.924,474.5c.173.088.858-1.6,2.676-2.507,1.791-.968,3.485-.524,3.523-.721.026-.079-.363-.327-1.079-.43a4.7,4.7,0,0,0-2.744.521,4.988,4.988,0,0,0-2.051,1.977C377.894,474,377.848,474.478,377.924,474.5Z",
    transform: "translate(-377.893 -470.809)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17815",
    "data-name": "Grupo 17815",
    transform: "translate(19.607 41.016)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17814",
    "data-name": "Grupo 17814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17813",
    "data-name": "Grupo 17813"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17812",
    "data-name": "Grupo 17812"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17811",
    "data-name": "Grupo 17811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17810",
    "data-name": "Grupo 17810"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12904",
    "data-name": "Trazado 12904",
    d: "M380.057,478.62c.145.138,1.125-.909,2.707-1.391,1.572-.518,2.941-.216,2.989-.416.088-.164-1.388-.838-3.184-.257C380.768,477.116,379.9,478.535,380.057,478.62Z",
    transform: "translate(-380.038 -476.324)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17821",
    "data-name": "Grupo 17821",
    transform: "translate(13.333 29.735)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17820",
    "data-name": "Grupo 17820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17819",
    "data-name": "Grupo 17819"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17818",
    "data-name": "Grupo 17818"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17817",
    "data-name": "Grupo 17817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17816",
    "data-name": "Grupo 17816"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12905",
    "data-name": "Trazado 12905",
    d: "M373.962,469.182c.144.152,1.643-1.467,4.04-2.442,2.383-1.015,4.533-.915,4.538-1.129.049-.171-2.228-.607-4.787.473C375.186,467.138,373.815,469.093,373.962,469.182Z",
    transform: "translate(-373.952 -465.379)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17827",
    "data-name": "Grupo 17827",
    transform: "translate(12.797 24.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17826",
    "data-name": "Grupo 17826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17825",
    "data-name": "Grupo 17825"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17824",
    "data-name": "Grupo 17824"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17823",
    "data-name": "Grupo 17823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17822",
    "data-name": "Grupo 17822"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12906",
    "data-name": "Trazado 12906",
    d: "M373.435,461.626c.082.192,1.772-.556,3.973-.648,2.2-.125,3.948.453,4.013.255.085-.158-1.68-1.086-4.045-.959C375.011,460.38,373.338,461.477,373.435,461.626Z",
    transform: "translate(-373.431 -460.261)",
    fill: "#263238"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17833",
    "data-name": "Grupo 17833",
    transform: "translate(12.967 19.269)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17832",
    "data-name": "Grupo 17832"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17831",
    "data-name": "Grupo 17831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17830",
    "data-name": "Grupo 17830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17829",
    "data-name": "Grupo 17829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17828",
    "data-name": "Grupo 17828"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12907",
    "data-name": "Trazado 12907",
    d: "M378.657,461.062a2.892,2.892,0,0,0-.172-1.2,8.573,8.573,0,0,0-1.464-2.946,3.6,3.6,0,0,0-1.817-1.458,1.236,1.236,0,0,0-1.346.563,2.239,2.239,0,0,0-.222,1.517,4.466,4.466,0,0,0,4.576,3.475,5.2,5.2,0,0,0,4.471-3.745,1.944,1.944,0,0,0-.191-1.545,1.2,1.2,0,0,0-1.392-.425,4.434,4.434,0,0,0-1.79,1.469,9.51,9.51,0,0,0-1.616,2.853,3,3,0,0,0-.268,1.18,15.164,15.164,0,0,1,2.238-3.7,4.122,4.122,0,0,1,1.59-1.24.642.642,0,0,1,.761.227,1.337,1.337,0,0,1,.068,1.023,4.637,4.637,0,0,1-3.913,3.2,3.87,3.87,0,0,1-3.925-2.891,1.627,1.627,0,0,1,.112-1.066.67.67,0,0,1,.738-.323,3.245,3.245,0,0,1,1.56,1.206A12.687,12.687,0,0,1,378.657,461.062Z",
    transform: "translate(-373.596 -455.224)",
    fill: "#263238"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17847",
    "data-name": "Grupo 17847",
    transform: "translate(22.439 156.758)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17837",
    "data-name": "Grupo 17837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17836",
    "data-name": "Grupo 17836"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17835",
    "data-name": "Grupo 17835"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12908",
    "data-name": "Trazado 12908",
    d: "M392.6,265.855a107.106,107.106,0,0,1,7.994,21.561c3.528,13.317,7.491,20,6.049,44.552-.736,12.526-11.095,46.526-13.482,58.491-1.965,9.847-8.107,56.125-11.22,68.354H364.1l-1.817-136.978s-28.352,79.936-31.984,89.178-16.21,45.848-16.21,45.848l-22.185-5.9s13.553-65.528,16.926-81.835,12.538-62.349,16.431-76.21,7.585-28.479,7.585-28.479Z",
    transform: "translate(-291.903 -264.436)",
    fill: "#1a1a1a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17840",
    "data-name": "Grupo 17840",
    transform: "translate(98.514 25.668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17839",
    "data-name": "Grupo 17839"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17838",
    "data-name": "Grupo 17838"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12909",
    "data-name": "Trazado 12909",
    d: "M387.488,289.34a1.97,1.97,0,0,0,.184.679,10.487,10.487,0,0,0,.8,1.727,14.719,14.719,0,0,0,4.131,4.614,13.957,13.957,0,0,0,5.577,2.429,9.475,9.475,0,0,0,1.826.179c.433,0,.671-.023.671-.059,0-.093-.95-.123-2.427-.479a15.592,15.592,0,0,1-5.367-2.5,16.384,16.384,0,0,1-4.117-4.384C387.932,290.228,387.571,289.3,387.488,289.34Z",
    transform: "translate(-387.481 -289.339)",
    fill: "#1b202c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17843",
    "data-name": "Grupo 17843",
    transform: "translate(31.538 28.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17842",
    "data-name": "Grupo 17842"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17841",
    "data-name": "Grupo 17841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12910",
    "data-name": "Trazado 12910",
    d: "M322.5,299.216c-.005.035.226.1.652.192a9.709,9.709,0,0,0,1.837.2,11.469,11.469,0,0,0,2.737-.274,12.615,12.615,0,0,0,3.167-1.208,15.569,15.569,0,0,0,4.658-4.087,8.935,8.935,0,0,0,1.38-2.2,25.546,25.546,0,0,0-1.645,1.961,17.513,17.513,0,0,1-4.623,3.867,12.768,12.768,0,0,1-5.678,1.574C323.463,299.288,322.514,299.121,322.5,299.216Z",
    transform: "translate(-322.501 -291.836)",
    fill: "#1b202c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17846",
    "data-name": "Grupo 17846",
    transform: "translate(69.243 27.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17845",
    "data-name": "Grupo 17845"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17844",
    "data-name": "Grupo 17844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12911",
    "data-name": "Trazado 12911",
    d: "M359.937,291.494a4.871,4.871,0,0,0-.193,1.1c-.095.715-.2,1.753-.306,3.039-.212,2.571-.384,6.135-.353,10.073s.267,7.5.523,10.067c.128,1.283.25,2.319.358,3.031a4.847,4.847,0,0,0,.212,1.1,4.987,4.987,0,0,0-.021-1.122q-.084-1.245-.2-3.042c-.166-2.568-.342-6.116-.377-10.04s.085-7.475.207-10.044c.059-1.2.108-2.215.148-3.045A4.88,4.88,0,0,0,359.937,291.494Z",
    transform: "translate(-359.082 -291.494)",
    fill: "#1b202c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17850",
    "data-name": "Grupo 17850",
    transform: "translate(56.532 77.44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17849",
    "data-name": "Grupo 17849"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17848",
    "data-name": "Grupo 17848"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12912",
    "data-name": "Trazado 12912",
    d: "M384.847,189.093,401,196.8l-2.252,29.456s-1.9,2.233-5,18.016,7.253,46.5,7.253,46.5l-76.022,1.9s8.922-63.712,9.955-72.143l3.794-32.213,15.282-.836h4.407l3.8,27.459,19.129-26.629Z",
    transform: "translate(-324.98 -187.482)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17853",
    "data-name": "Grupo 17853",
    transform: "translate(42.357 125.455)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17852",
    "data-name": "Grupo 17852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17851",
    "data-name": "Grupo 17851"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12913",
    "data-name": "Trazado 12913",
    d: "M315.008,244.788a4.359,4.359,0,0,0,.236-1.736,12.373,12.373,0,0,0-.7-4.171,11.976,11.976,0,0,0-2.051-3.651c-.689-.815-1.217-1.2-1.255-1.16a20.947,20.947,0,0,1,2.844,4.99A21.632,21.632,0,0,1,315.008,244.788Z",
    transform: "translate(-311.228 -234.067)",
    fill: "#263238"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17855",
    "data-name": "Grupo 17855",
    transform: "translate(6.207 78.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17854",
    "data-name": "Grupo 17854"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12914",
    "data-name": "Trazado 12914",
    d: "M285.229,238.888l27.076-.236,10.241-30.243h0a117.838,117.838,0,0,1,5.356-10.664c5.427-9.975,12.317-9.452,12.317-9.452l8.312,12.926-8.824,19.8S331.262,258.355,321.479,260c-16.247,2.724-45.324-8.506-45.324-8.506Z",
    transform: "translate(-276.155 -188.288)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17858",
    "data-name": "Grupo 17858",
    transform: "translate(62.755 135.172)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17857",
    "data-name": "Grupo 17857"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17856",
    "data-name": "Grupo 17856"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12915",
    "data-name": "Trazado 12915",
    d: "M331.072,246.461c-.026-1.03-.281-2.355.607-2.8a3,3,0,0,1,2.3.173c22.435,7.953,35.417-1.279,57.851,6.675l4.569,23.042c-9.954.081-14.506-2.246-24.3-5.378-9.984-3.194-19.973-6.392-29.765-10.18a27.151,27.151,0,0,1-7.7-4.031A9.785,9.785,0,0,1,331.072,246.461Z",
    transform: "translate(-331.018 -243.494)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17860",
    "data-name": "Grupo 17860",
    transform: "translate(65.872 100.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17859",
    "data-name": "Grupo 17859"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12916",
    "data-name": "Trazado 12916",
    d: "M336.419,209.4a7.856,7.856,0,0,1-.523,1.528,25.665,25.665,0,0,0-.938,3.738c-.531,2.978-.636,5.446-.789,5.444a15.854,15.854,0,0,1,.26-5.54,16.364,16.364,0,0,1,1.114-3.783A3.675,3.675,0,0,1,336.419,209.4Z",
    transform: "translate(-334.041 -209.397)",
    fill: "#e5e5e5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17912",
    "data-name": "Grupo 17912",
    transform: "translate(0 86.293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17871",
    "data-name": "Grupo 17871",
    transform: "translate(0 30.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17862",
    "data-name": "Grupo 17862",
    transform: "translate(281.05 12.754)",
    opacity: 0.996
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_4577",
    "data-name": "Rect\\xE1ngulo 4577",
    d: "M0,0H6.4a6.24,6.24,0,0,1,6.24,6.24v1.15a6.24,6.24,0,0,1-6.24,6.24H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "matrix(1, 0.026, -0.026, 1, 0.351, 0)",
    fill: "#e02a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17863",
    "data-name": "Grupo 17863",
    transform: "translate(9.488 1.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12917",
    "data-name": "Trazado 12917",
    d: "M206.883,232.547l55.433-5.595,186.268,4.792,22.02.567a3.674,3.674,0,0,1,3.577,3.766l-.5,19.55a3.674,3.674,0,0,1-3.766,3.577l-209.079-5.38L206.621,242.7Z",
    transform: "translate(-206.621 -226.952)",
    fill: "#e02a58",
    opacity: 0.996
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17864",
    "data-name": "Grupo 17864",
    transform: "translate(0 9.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12918",
    "data-name": "Trazado 12918",
    d: "M207.078,235.157l-5.095-.131-4.328,1.467c-.359.268-.268.611-.026.979l4.355,1.418,4.994.129Z",
    transform: "translate(-197.416 -235.026)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17865",
    "data-name": "Grupo 17865",
    transform: "translate(64.491 1.301)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_4578",
    "data-name": "Rect\\xE1ngulo 4578",
    width: 4.324,
    height: 26.901,
    transform: "translate(0.692 0) rotate(1.474)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17869",
    "data-name": "Grupo 17869",
    transform: "translate(163.948)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17866",
    "data-name": "Grupo 17866",
    transform: "translate(0.27 0.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12919",
    "data-name": "Trazado 12919",
    d: "M470.283,233.533h0a4.79,4.79,0,0,1-4.911,4.664l-103.964-2.676a4.789,4.789,0,0,1-4.665-4.91h0a4.789,4.789,0,0,1,4.911-4.664l103.964,2.675A4.789,4.789,0,0,1,470.283,233.533Z",
    transform: "translate(-356.74 -225.945)",
    fill: "#e02a58"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17868",
    "data-name": "Grupo 17868"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17867",
    "data-name": "Grupo 17867"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12920",
    "data-name": "Trazado 12920",
    d: "M470.291,233.541a5.4,5.4,0,0,0-.587-2.308,4.767,4.767,0,0,0-2.034-1.992,4.7,4.7,0,0,0-1.755-.5c-.656-.042-1.375-.035-2.125-.057l-25.505-.571-37.826-.916-22.336-.559-11.815-.3-3.011-.077a11,11,0,0,0-2.941.115,4.52,4.52,0,0,0-.231,8.656,10.886,10.886,0,0,0,2.93.269l3.012.077,11.817.308,22.34.591,37.826,1.031,25.5.742c.75.016,1.469.061,2.124.052a4.683,4.683,0,0,0,1.779-.406,4.767,4.767,0,0,0,2.133-1.885,5.415,5.415,0,0,0,.705-2.273,3.731,3.731,0,0,1-.033.615,4.578,4.578,0,0,1-.579,1.712,4.844,4.844,0,0,1-4,2.421c-.679.018-1.382-.019-2.137-.028l-25.5-.571-37.829-.915-22.341-.56-11.817-.3-3.012-.076-1.514-.039a5.5,5.5,0,0,1-1.571-.256,5.055,5.055,0,0,1,.259-9.683,5.5,5.5,0,0,1,1.581-.172l1.514.039,3.011.078,11.814.308,22.336.591,37.822,1.031,25.5.741c.755.03,1.458.031,2.136.082a4.848,4.848,0,0,1,3.869,2.623,4.575,4.575,0,0,1,.491,1.741A3.669,3.669,0,0,1,470.291,233.541Z",
    transform: "translate(-356.478 -225.689)",
    fill: "#1b202c"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17870",
    "data-name": "Grupo 17870",
    transform: "translate(276.534 9.099)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12921",
    "data-name": "Trazado 12921",
    d: "M466.256,234.517l5.34,2.714-.4,15.451-5.489,3.08Z",
    transform: "translate(-465.709 -234.517)",
    fill: "#1b202c"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17884",
    "data-name": "Grupo 17884",
    transform: "translate(161.266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17877",
    "data-name": "Grupo 17877",
    transform: "translate(34.759)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17873",
    "data-name": "Grupo 17873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17872",
    "data-name": "Grupo 17872"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12922",
    "data-name": "Trazado 12922",
    d: "M405.684,246.57l-11.8-18.182h0l-1.059-1.631,0,0-1.589-2.459,6.93-28.225s5.921,2.718,9.174,7.254a107.734,107.734,0,0,1,7.229,12.881s11.544,26.408,13.442,30.349,4.963,11.239,0,15.327-38.177,4.223-38.177,4.223L387.6,249.42Z",
    transform: "translate(-387.6 -196.071)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17876",
    "data-name": "Grupo 17876",
    transform: "translate(2.812 4.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17875",
    "data-name": "Grupo 17875"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17874",
    "data-name": "Grupo 17874"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12923",
    "data-name": "Trazado 12923",
    d: "M391.054,221.187c.088-.018-.17-1.238-.279-3.23a25.675,25.675,0,0,1,3.789-14.848c1.049-1.7,1.86-2.644,1.791-2.7-.025-.023-.246.2-.625.617a16.545,16.545,0,0,0-1.461,1.9,23.311,23.311,0,0,0-3.842,15.062,16.535,16.535,0,0,0,.373,2.363A3.022,3.022,0,0,0,391.054,221.187Z",
    transform: "translate(-390.328 -200.406)",
    fill: "#e5e5e5"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17883",
    "data-name": "Grupo 17883",
    transform: "translate(0 46.487)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17879",
    "data-name": "Grupo 17879"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17878",
    "data-name": "Grupo 17878"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12924",
    "data-name": "Trazado 12924",
    d: "M384.815,251.111a11.419,11.419,0,0,0-2.991-3.949c-2.175-1.889-6.949-3.353-7.568-5.162s-2.428-.406-2.006,1.849c.27,1.437,3.226,5.2,3.226,5.2s-3.47.871-5.781-.461-10.4-3.724-11.267-2.593c-.978,1.279,1.14,1.706,2.05,2.221.692.393,6.069,3.059,6.069,3.059s-10.7-.365-12.05.144c-1.466.553.035,1.848.71,1.876.425.016,2.258,1.654,3.557,2.864a4.857,4.857,0,0,0,3.243,1.3l2.487.037-7.555.793s-1.306,1.195.511,1.817c.81.278,21.749,2.171,23.527,2.112,4.029-.135,9.642-.412,9.642-.412l-.983-11.341Z",
    transform: "translate(-353.877 -241.173)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17882",
    "data-name": "Grupo 17882",
    transform: "translate(1.139 12.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17881",
    "data-name": "Grupo 17881"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17880",
    "data-name": "Grupo 17880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12925",
    "data-name": "Trazado 12925",
    d: "M354.982,253.064a22.611,22.611,0,0,0,10.4,1.855c.005-.146-2.359-.281-5.222-.8S355.028,252.925,354.982,253.064Z",
    transform: "translate(-354.981 -253.046)",
    fill: "#eb996e"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17911",
    "data-name": "Grupo 17911",
    transform: "translate(76.407 44.404)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17886",
    "data-name": "Grupo 17886",
    transform: "translate(7.006 1.108)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17885",
    "data-name": "Grupo 17885"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12926",
    "data-name": "Trazado 12926",
    d: "M278.343,240.318c2.056-.45,4.043.865,5.739,2.113a25.889,25.889,0,0,1,3.036,2.478c2.608,2.608,3.981,6.185,6.176,9.15l-12.332-1.879Z",
    transform: "translate(-278.343 -240.227)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17910",
    "data-name": "Grupo 17910"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17889",
    "data-name": "Grupo 17889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17888",
    "data-name": "Grupo 17888"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17887",
    "data-name": "Grupo 17887"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12927",
    "data-name": "Trazado 12927",
    d: "M297.429,254.6l-5.388-1.124s-4.846-7.732-7.393-8.666l-1.434-.639s-1.871-4.1-4.412-3.577c-1.511-.99-2.865-.594-3.011.914,0,0-.749-3.433-3.557-2.018s3.882,13.3,3.882,13.3,2.345,6.088,5.264,4.055c0,0,2.913.68,4.863-.408,0,0,1.806,2.542,6.075.6Z",
    transform: "translate(-271.546 -239.152)",
    fill: "#ffbe9d"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17893",
    "data-name": "Grupo 17893",
    transform: "translate(14.113 15.195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17892",
    "data-name": "Grupo 17892"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17891",
    "data-name": "Grupo 17891"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17890",
    "data-name": "Grupo 17890"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12928",
    "data-name": "Trazado 12928",
    d: "M285.294,254.562c-.027,0-.088.2-.034.574a2.552,2.552,0,0,0,.747,1.385,3.521,3.521,0,0,0,2.115.994,7.259,7.259,0,0,0,2.813-.305,17.69,17.69,0,0,0,4.625-2.025,6.137,6.137,0,0,0,1.649-1.283,32.119,32.119,0,0,1-6.406,2.832,7.333,7.333,0,0,1-2.63.329,3.3,3.3,0,0,1-1.926-.8A3.15,3.15,0,0,1,285.294,254.562Z",
    transform: "translate(-285.238 -253.894)",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17897",
    "data-name": "Grupo 17897",
    transform: "translate(3.93 1.621)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17896",
    "data-name": "Grupo 17896"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17895",
    "data-name": "Grupo 17895"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17894",
    "data-name": "Grupo 17894"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12929",
    "data-name": "Trazado 12929",
    d: "M280.437,252.236c.125-.086-1.491-2.418-2.878-5.6-1.408-3.176-2.032-5.943-2.18-5.909a5.884,5.884,0,0,0,.281,1.845,25.935,25.935,0,0,0,3.608,8.212A5.848,5.848,0,0,0,280.437,252.236Z",
    transform: "translate(-275.359 -240.725)",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17901",
    "data-name": "Grupo 17901",
    transform: "translate(7.24 1.446)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17900",
    "data-name": "Grupo 17900"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17899",
    "data-name": "Grupo 17899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17898",
    "data-name": "Grupo 17898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12930",
    "data-name": "Trazado 12930",
    d: "M283.428,251.982c.127-.075-1.237-2.5-2.564-5.651s-2.136-5.814-2.277-5.775a29.888,29.888,0,0,0,4.841,11.427Z",
    transform: "translate(-278.571 -240.555)",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17905",
    "data-name": "Grupo 17905",
    transform: "translate(7.911 15.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17904",
    "data-name": "Grupo 17904"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17903",
    "data-name": "Grupo 17903"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17902",
    "data-name": "Grupo 17902"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12931",
    "data-name": "Trazado 12931",
    d: "M279.268,254.31c-.134.006-.018.988.863,1.719s1.86.683,1.843.55c.014-.142-.794-.3-1.525-.929C279.7,255.04,279.405,254.271,279.268,254.31Z",
    transform: "translate(-279.222 -254.309)",
    fill: "#eb996e"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17909",
    "data-name": "Grupo 17909",
    transform: "translate(11.823 5.237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17908",
    "data-name": "Grupo 17908"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17907",
    "data-name": "Grupo 17907"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17906",
    "data-name": "Grupo 17906"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12932",
    "data-name": "Trazado 12932",
    d: "M286.646,250.169a83.883,83.883,0,0,0-3.613-5.934,14.521,14.521,0,0,0,3.613,5.934Z",
    transform: "translate(-283.017 -244.233)",
    fill: "#eb996e"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagenLogin);
export default __webpack_public_path__ + "static/media/imagenLogin.45878ab87835477f197e08f9383f26f9.svg";
export { ForwardRef as ReactComponent };